(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3643],{

/***/ 2711:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():0}(this,function(){"use strict";var e="undefined"!=typeof window?window:"undefined"!=typeof __webpack_require__.g?__webpack_require__.g:"undefined"!=typeof self?self:{},t="Expected a function",n=NaN,o="[object Symbol]",i=/^\s+|\s+$/g,a=/^[-+]0x[0-9a-f]+$/i,r=/^0b[01]+$/i,c=/^0o[0-7]+$/i,s=parseInt,u="object"==typeof e&&e&&e.Object===Object&&e,d="object"==typeof self&&self&&self.Object===Object&&self,l=u||d||Function("return this")(),f=Object.prototype.toString,m=Math.max,p=Math.min,b=function(){return l.Date.now()};function v(e,n,o){var i,a,r,c,s,u,d=0,l=!1,f=!1,v=!0;if("function"!=typeof e)throw new TypeError(t);function y(t){var n=i,o=a;return i=a=void 0,d=t,c=e.apply(o,n)}function h(e){var t=e-u;return void 0===u||t>=n||t<0||f&&e-d>=r}function k(){var e=b();if(h(e))return x(e);s=setTimeout(k,function(e){var t=n-(e-u);return f?p(t,r-(e-d)):t}(e))}function x(e){return s=void 0,v&&i?y(e):(i=a=void 0,c)}function O(){var e=b(),t=h(e);if(i=arguments,a=this,u=e,t){if(void 0===s)return function(e){return d=e,s=setTimeout(k,n),l?y(e):c}(u);if(f)return s=setTimeout(k,n),y(u)}return void 0===s&&(s=setTimeout(k,n)),c}return n=w(n)||0,g(o)&&(l=!!o.leading,r=(f="maxWait"in o)?m(w(o.maxWait)||0,n):r,v="trailing"in o?!!o.trailing:v),O.cancel=function(){void 0!==s&&clearTimeout(s),d=0,i=u=a=s=void 0},O.flush=function(){return void 0===s?c:x(b())},O}function g(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function w(e){if("number"==typeof e)return e;if(function(e){return"symbol"==typeof e||function(e){return!!e&&"object"==typeof e}(e)&&f.call(e)==o}(e))return n;if(g(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=g(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(i,"");var u=r.test(e);return u||c.test(e)?s(e.slice(2),u?2:8):a.test(e)?n:+e}var y=function(e,n,o){var i=!0,a=!0;if("function"!=typeof e)throw new TypeError(t);return g(o)&&(i="leading"in o?!!o.leading:i,a="trailing"in o?!!o.trailing:a),v(e,n,{leading:i,maxWait:n,trailing:a})},h="Expected a function",k=NaN,x="[object Symbol]",O=/^\s+|\s+$/g,j=/^[-+]0x[0-9a-f]+$/i,E=/^0b[01]+$/i,N=/^0o[0-7]+$/i,z=parseInt,C="object"==typeof e&&e&&e.Object===Object&&e,A="object"==typeof self&&self&&self.Object===Object&&self,q=C||A||Function("return this")(),L=Object.prototype.toString,T=Math.max,M=Math.min,S=function(){return q.Date.now()};function D(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function H(e){if("number"==typeof e)return e;if(function(e){return"symbol"==typeof e||function(e){return!!e&&"object"==typeof e}(e)&&L.call(e)==x}(e))return k;if(D(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=D(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(O,"");var n=E.test(e);return n||N.test(e)?z(e.slice(2),n?2:8):j.test(e)?k:+e}var $=function(e,t,n){var o,i,a,r,c,s,u=0,d=!1,l=!1,f=!0;if("function"!=typeof e)throw new TypeError(h);function m(t){var n=o,a=i;return o=i=void 0,u=t,r=e.apply(a,n)}function p(e){var n=e-s;return void 0===s||n>=t||n<0||l&&e-u>=a}function b(){var e=S();if(p(e))return v(e);c=setTimeout(b,function(e){var n=t-(e-s);return l?M(n,a-(e-u)):n}(e))}function v(e){return c=void 0,f&&o?m(e):(o=i=void 0,r)}function g(){var e=S(),n=p(e);if(o=arguments,i=this,s=e,n){if(void 0===c)return function(e){return u=e,c=setTimeout(b,t),d?m(e):r}(s);if(l)return c=setTimeout(b,t),m(s)}return void 0===c&&(c=setTimeout(b,t)),r}return t=H(t)||0,D(n)&&(d=!!n.leading,a=(l="maxWait"in n)?T(H(n.maxWait)||0,t):a,f="trailing"in n?!!n.trailing:f),g.cancel=function(){void 0!==c&&clearTimeout(c),u=0,o=s=i=c=void 0},g.flush=function(){return void 0===c?r:v(S())},g},W=function(){};function P(e){e&&e.forEach(function(e){var t=Array.prototype.slice.call(e.addedNodes),n=Array.prototype.slice.call(e.removedNodes);if(function e(t){var n=void 0,o=void 0;for(n=0;n<t.length;n+=1){if((o=t[n]).dataset&&o.dataset.aos)return!0;if(o.children&&e(o.children))return!0}return!1}(t.concat(n)))return W()})}function Y(){return window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver}var _={isSupported:function(){return!!Y()},ready:function(e,t){var n=window.document,o=new(Y())(P);W=t,o.observe(n.documentElement,{childList:!0,subtree:!0,removedNodes:!0})}},B=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},F=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),I=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},K=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,G=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,J=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,Q=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;function R(){return navigator.userAgent||navigator.vendor||window.opera||""}var U=new(function(){function e(){B(this,e)}return F(e,[{key:"phone",value:function(){var e=R();return!(!K.test(e)&&!G.test(e.substr(0,4)))}},{key:"mobile",value:function(){var e=R();return!(!J.test(e)&&!Q.test(e.substr(0,4)))}},{key:"tablet",value:function(){return this.mobile()&&!this.phone()}},{key:"ie11",value:function(){return"-ms-scroll-limit"in document.documentElement.style&&"-ms-ime-align"in document.documentElement.style}}]),e}()),V=function(e,t){var n=void 0;return U.ie11()?(n=document.createEvent("CustomEvent")).initCustomEvent(e,!0,!0,{detail:t}):n=new CustomEvent(e,{detail:t}),document.dispatchEvent(n)},X=function(e){return e.forEach(function(e,t){return function(e,t){var n=e.options,o=e.position,i=e.node,a=(e.data,function(){e.animated&&(function(e,t){t&&t.forEach(function(t){return e.classList.remove(t)})}(i,n.animatedClassNames),V("aos:out",i),e.options.id&&V("aos:in:"+e.options.id,i),e.animated=!1)});n.mirror&&t>=o.out&&!n.once?a():t>=o.in?e.animated||(function(e,t){t&&t.forEach(function(t){return e.classList.add(t)})}(i,n.animatedClassNames),V("aos:in",i),e.options.id&&V("aos:in:"+e.options.id,i),e.animated=!0):e.animated&&!n.once&&a()}(e,window.pageYOffset)})},Z=function(e){for(var t=0,n=0;e&&!isNaN(e.offsetLeft)&&!isNaN(e.offsetTop);)t+=e.offsetLeft-("BODY"!=e.tagName?e.scrollLeft:0),n+=e.offsetTop-("BODY"!=e.tagName?e.scrollTop:0),e=e.offsetParent;return{top:n,left:t}},ee=function(e,t,n){var o=e.getAttribute("data-aos-"+t);if(void 0!==o){if("true"===o)return!0;if("false"===o)return!1}return o||n},te=function(e,t){return e.forEach(function(e,n){var o=ee(e.node,"mirror",t.mirror),i=ee(e.node,"once",t.once),a=ee(e.node,"id"),r=t.useClassNames&&e.node.getAttribute("data-aos"),c=[t.animatedClassName].concat(r?r.split(" "):[]).filter(function(e){return"string"==typeof e});t.initClassName&&e.node.classList.add(t.initClassName),e.position={in:function(e,t,n){var o=window.innerHeight,i=ee(e,"anchor"),a=ee(e,"anchor-placement"),r=Number(ee(e,"offset",a?0:t)),c=a||n,s=e;i&&document.querySelectorAll(i)&&(s=document.querySelectorAll(i)[0]);var u=Z(s).top-o;switch(c){case"top-bottom":break;case"center-bottom":u+=s.offsetHeight/2;break;case"bottom-bottom":u+=s.offsetHeight;break;case"top-center":u+=o/2;break;case"center-center":u+=o/2+s.offsetHeight/2;break;case"bottom-center":u+=o/2+s.offsetHeight;break;case"top-top":u+=o;break;case"bottom-top":u+=o+s.offsetHeight;break;case"center-top":u+=o+s.offsetHeight/2}return u+r}(e.node,t.offset,t.anchorPlacement),out:o&&function(e,t){window.innerHeight;var n=ee(e,"anchor"),o=ee(e,"offset",t),i=e;return n&&document.querySelectorAll(n)&&(i=document.querySelectorAll(n)[0]),Z(i).top+i.offsetHeight-o}(e.node,t.offset)},e.options={once:i,mirror:o,animatedClassNames:c,id:a}}),e},ne=function(){var e=document.querySelectorAll("[data-aos]");return Array.prototype.map.call(e,function(e){return{node:e}})},oe=[],ie=!1,ae={offset:120,delay:0,easing:"ease",duration:400,disable:!1,once:!1,mirror:!1,anchorPlacement:"top-bottom",startEvent:"DOMContentLoaded",animatedClassName:"aos-animate",initClassName:"aos-init",useClassNames:!1,disableMutationObserver:!1,throttleDelay:99,debounceDelay:50},re=function(){return document.all&&!window.atob},ce=function(){arguments.length>0&&void 0!==arguments[0]&&arguments[0]&&(ie=!0),ie&&(oe=te(oe,ae),X(oe),window.addEventListener("scroll",y(function(){X(oe,ae.once)},ae.throttleDelay)))},se=function(){if(oe=ne(),de(ae.disable)||re())return ue();ce()},ue=function(){oe.forEach(function(e,t){e.node.removeAttribute("data-aos"),e.node.removeAttribute("data-aos-easing"),e.node.removeAttribute("data-aos-duration"),e.node.removeAttribute("data-aos-delay"),ae.initClassName&&e.node.classList.remove(ae.initClassName),ae.animatedClassName&&e.node.classList.remove(ae.animatedClassName)})},de=function(e){return!0===e||"mobile"===e&&U.mobile()||"phone"===e&&U.phone()||"tablet"===e&&U.tablet()||"function"==typeof e&&!0===e()};return{init:function(e){return ae=I(ae,e),oe=ne(),ae.disableMutationObserver||_.isSupported()||(console.info('\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '),ae.disableMutationObserver=!0),ae.disableMutationObserver||_.ready("[data-aos]",se),de(ae.disable)||re()?ue():(document.querySelector("body").setAttribute("data-aos-easing",ae.easing),document.querySelector("body").setAttribute("data-aos-duration",ae.duration),document.querySelector("body").setAttribute("data-aos-delay",ae.delay),-1===["DOMContentLoaded","load"].indexOf(ae.startEvent)?document.addEventListener(ae.startEvent,function(){ce(!0)}):window.addEventListener("load",function(){ce(!0)}),"DOMContentLoaded"===ae.startEvent&&["complete","interactive"].indexOf(document.readyState)>-1&&ce(!0),window.addEventListener("resize",$(ce,ae.debounceDelay,!0)),window.addEventListener("orientationchange",$(ce,ae.debounceDelay,!0)),oe)},refresh:ce,refreshHard:se}});


/***/ }),

/***/ 26246:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OO": function() { return /* binding */ $r; }
/* harmony export */ });
/* unused harmony exports GroupedVirtuoso, LogLevel, TableVirtuoso, VirtuosoGrid, VirtuosoGridMockContext, VirtuosoMockContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);



const Ce = 0, Lt = 1, Yt = 2, En = 4;
function sn(t) {
  return () => t;
}
function lo(t) {
  t();
}
function ne(t, e) {
  return (n) => t(e(n));
}
function ln(t, e) {
  return () => t(e);
}
function Hn(t, e) {
  return (n) => t(e, n);
}
function Ae(t) {
  return t !== void 0;
}
function co(...t) {
  return () => {
    t.map(lo);
  };
}
function Gt() {
}
function ye(t, e) {
  return e(t), t;
}
function uo(t, e) {
  return e(t);
}
function X(...t) {
  return t;
}
function K(t, e) {
  return t(Lt, e);
}
function M(t, e) {
  t(Ce, e);
}
function We(t) {
  t(Yt);
}
function lt(t) {
  return t(En);
}
function F(t, e) {
  return K(t, Hn(e, Ce));
}
function Rt(t, e) {
  const n = t(Lt, (o) => {
    n(), e(o);
  });
  return n;
}
function cn(t) {
  let e, n;
  return (o) => (r) => {
    e = r, n && clearTimeout(n), n = setTimeout(() => {
      o(e);
    }, t);
  };
}
function Bn(t, e) {
  return t === e;
}
function Y(t = Bn) {
  let e;
  return (n) => (o) => {
    t(e, o) || (e = o, n(o));
  };
}
function V(t) {
  return (e) => (n) => {
    t(n) && e(n);
  };
}
function H(t) {
  return (e) => ne(e, t);
}
function vt(t) {
  return (e) => () => {
    e(t);
  };
}
function x(t, ...e) {
  const n = ao(...e);
  return (o, r) => {
    switch (o) {
      case Yt:
        We(t);
        return;
      case Lt:
        return K(t, n(r));
    }
  };
}
function bt(t, e) {
  return (n) => (o) => {
    n(e = t(e, o));
  };
}
function qt(t) {
  return (e) => (n) => {
    t > 0 ? t-- : e(n);
  };
}
function zt(t) {
  let e = null, n;
  return (o) => (r) => {
    e = r, !n && (n = setTimeout(() => {
      n = void 0, o(e);
    }, t));
  };
}
function G(...t) {
  const e = new Array(t.length);
  let n = 0, o = null;
  const r = Math.pow(2, t.length) - 1;
  return t.forEach((s, i) => {
    const l = Math.pow(2, i);
    K(s, (c) => {
      const d = n;
      n = n | l, e[i] = c, d !== r && n === r && o && (o(), o = null);
    });
  }), (s) => (i) => {
    const l = () => {
      s([i].concat(e));
    };
    n === r ? l() : o = l;
  };
}
function ao(...t) {
  return (e) => t.reduceRight(uo, e);
}
function fo(t) {
  let e, n;
  const o = () => e == null ? void 0 : e();
  return function(r, s) {
    switch (r) {
      case Lt:
        return s ? n === s ? void 0 : (o(), n = s, e = K(t, s), e) : (o(), Gt);
      case Yt:
        o(), n = null;
        return;
    }
  };
}
function w(t) {
  let e = t;
  const n = $();
  return (o, r) => {
    switch (o) {
      case Ce:
        e = r;
        break;
      case Lt: {
        r(e);
        break;
      }
      case En:
        return e;
    }
    return n(o, r);
  };
}
function ct(t, e) {
  return ye(w(e), (n) => F(t, n));
}
function $() {
  const t = [];
  return (e, n) => {
    switch (e) {
      case Ce:
        t.slice().forEach((o) => {
          o(n);
        });
        return;
      case Yt:
        t.splice(0, t.length);
        return;
      case Lt:
        return t.push(n), () => {
          const o = t.indexOf(n);
          o > -1 && t.splice(o, 1);
        };
    }
  };
}
function pt(t) {
  return ye($(), (e) => F(t, e));
}
function U(t, e = [], { singleton: n } = { singleton: !0 }) {
  return {
    constructor: t,
    dependencies: e,
    id: mo(),
    singleton: n
  };
}
const mo = () => Symbol();
function po(t) {
  const e = /* @__PURE__ */ new Map(), n = ({ constructor: o, dependencies: r, id: s, singleton: i }) => {
    if (i && e.has(s))
      return e.get(s);
    const l = o(r.map((c) => n(c)));
    return i && e.set(s, l), l;
  };
  return n(t);
}
function rt(...t) {
  const e = $(), n = new Array(t.length);
  let o = 0;
  const r = Math.pow(2, t.length) - 1;
  return t.forEach((s, i) => {
    const l = Math.pow(2, i);
    K(s, (c) => {
      n[i] = c, o = o | l, o === r && M(e, n);
    });
  }), function(s, i) {
    switch (s) {
      case Yt: {
        We(e);
        return;
      }
      case Lt:
        return o === r && i(n), K(e, i);
    }
  };
}
function A(t, e = Bn) {
  return x(t, Y(e));
}
function un(...t) {
  return function(e, n) {
    switch (e) {
      case Yt:
        return;
      case Lt:
        return co(...t.map((o) => K(o, n)));
    }
  };
}
var ht = /* @__PURE__ */ ((t) => (t[t.DEBUG = 0] = "DEBUG", t[t.INFO = 1] = "INFO", t[t.WARN = 2] = "WARN", t[t.ERROR = 3] = "ERROR", t))(ht || {});
const ho = {
  0: "debug",
  3: "error",
  1: "log",
  2: "warn"
}, go = () => typeof globalThis > "u" ? window : globalThis, Pt = U(
  () => {
    const t = w(
      3
      /* ERROR */
    );
    return {
      log: w((n, o, r = 1) => {
        var i;
        const s = (i = go().VIRTUOSO_LOG_LEVEL) != null ? i : lt(t);
        r >= s && console[ho[r]](
          "%creact-virtuoso: %c%s %o",
          "color: #0253b3; font-weight: bold",
          "color: initial",
          n,
          o
        );
      }),
      logLevel: t
    };
  },
  [],
  { singleton: !0 }
);
function Et(t, e, n) {
  return Me(t, e, n).callbackRef;
}
function Me(t, e, n) {
  const o = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
  let r = (s) => {
  };
  if (typeof ResizeObserver < "u") {
    const s = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => new ResizeObserver((i) => {
      const l = () => {
        const c = i[0].target;
        c.offsetParent !== null && t(c);
      };
      n ? l() : requestAnimationFrame(l);
    }), [t]);
    r = (i) => {
      i && e ? (s.observe(i), o.current = i) : (o.current && s.unobserve(o.current), o.current = null);
    };
  }
  return { callbackRef: r, ref: o };
}
function kn(t, e, n, o, r, s, i, l, c) {
  const d = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(
    (f) => {
      const S = Io(f.children, e, l ? "offsetWidth" : "offsetHeight", r);
      let p = f.parentElement;
      for (; !p.dataset.virtuosoScroller; )
        p = p.parentElement;
      const m = p.lastElementChild.dataset.viewportType === "window", C = i ? l ? i.scrollLeft : i.scrollTop : m ? l ? window.pageXOffset || document.documentElement.scrollLeft : window.pageYOffset || document.documentElement.scrollTop : l ? p.scrollLeft : p.scrollTop, I = i ? l ? i.scrollWidth : i.scrollHeight : m ? l ? document.documentElement.scrollWidth : document.documentElement.scrollHeight : l ? p.scrollWidth : p.scrollHeight, y = i ? l ? i.offsetWidth : i.offsetHeight : m ? l ? window.innerWidth : window.innerHeight : l ? p.offsetWidth : p.offsetHeight;
      o({
        scrollHeight: I,
        scrollTop: Math.max(C, 0),
        viewportHeight: y
      }), s == null || s(
        l ? an("column-gap", getComputedStyle(f).columnGap, r) : an("row-gap", getComputedStyle(f).rowGap, r)
      ), S !== null && t(S);
    },
    [t, e, r, s, i, o]
  );
  return Me(d, n, c);
}
function Io(t, e, n, o) {
  const r = t.length;
  if (r === 0)
    return null;
  const s = [];
  for (let i = 0; i < r; i++) {
    const l = t.item(i);
    if (l.dataset.index === void 0)
      continue;
    const c = parseInt(l.dataset.index), d = parseFloat(l.dataset.knownSize), f = e(l, n);
    if (f === 0 && o("Zero-sized element, this should not happen", { child: l }, ht.ERROR), f === d)
      continue;
    const S = s[s.length - 1];
    s.length === 0 || S.size !== f || S.endIndex !== c - 1 ? s.push({ endIndex: c, size: f, startIndex: c }) : s[s.length - 1].endIndex++;
  }
  return s;
}
function an(t, e, n) {
  return e !== "normal" && !(e != null && e.endsWith("px")) && n(`${t} was not resolved to pixel value correctly`, e, ht.WARN), e === "normal" ? 0 : parseInt(e != null ? e : "0", 10);
}
function _e(t, e, n) {
  const o = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), r = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(
    (c) => {
      if (!(c != null && c.offsetParent))
        return;
      const d = c.getBoundingClientRect(), f = d.width;
      let S, p;
      if (e) {
        const m = e.getBoundingClientRect(), C = d.top - m.top;
        p = m.height - Math.max(0, C), S = C + e.scrollTop;
      } else
        p = window.innerHeight - Math.max(0, d.top), S = d.top + window.pageYOffset;
      o.current = {
        offsetTop: S,
        visibleHeight: p,
        visibleWidth: f
      }, t(o.current);
    },
    [t, e]
  ), { callbackRef: s, ref: i } = Me(r, !0, n), l = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(() => {
    r(i.current);
  }, [r, i]);
  return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    if (e) {
      e.addEventListener("scroll", l);
      const c = new ResizeObserver(() => {
        requestAnimationFrame(l);
      });
      return c.observe(e), () => {
        e.removeEventListener("scroll", l), c.unobserve(e);
      };
    } else
      return window.addEventListener("scroll", l), window.addEventListener("resize", l), () => {
        window.removeEventListener("scroll", l), window.removeEventListener("resize", l);
      };
  }, [l, e]), s;
}
const at = U(
  () => {
    const t = $(), e = $(), n = w(0), o = $(), r = w(0), s = $(), i = $(), l = w(0), c = w(0), d = w(0), f = w(0), S = $(), p = $(), m = w(!1), C = w(!1), I = w(!1);
    return F(
      x(
        t,
        H(({ scrollTop: y }) => y)
      ),
      e
    ), F(
      x(
        t,
        H(({ scrollHeight: y }) => y)
      ),
      i
    ), F(e, r), {
      deviation: n,
      fixedFooterHeight: d,
      fixedHeaderHeight: c,
      footerHeight: f,
      headerHeight: l,
      horizontalDirection: C,
      scrollBy: p,
      // input
      scrollContainerState: t,
      scrollHeight: i,
      scrollingInProgress: m,
      // signals
      scrollTo: S,
      scrollTop: e,
      skipAnimationFrameInResizeObserver: I,
      smoothScrollTargetReached: o,
      // state
      statefulScrollTop: r,
      viewportHeight: s
    };
  },
  [],
  { singleton: !0 }
), oe = { lvl: 0 };
function On(t, e) {
  const n = t.length;
  if (n === 0)
    return [];
  let { index: o, value: r } = e(t[0]);
  const s = [];
  for (let i = 1; i < n; i++) {
    const { index: l, value: c } = e(t[i]);
    s.push({ end: l - 1, start: o, value: r }), o = l, r = c;
  }
  return s.push({ end: 1 / 0, start: o, value: r }), s;
}
function j(t) {
  return t === oe;
}
function re(t, e) {
  if (!j(t))
    return e === t.k ? t.v : e < t.k ? re(t.l, e) : re(t.r, e);
}
function wt(t, e, n = "k") {
  if (j(t))
    return [-1 / 0, void 0];
  if (Number(t[n]) === e)
    return [t.k, t.v];
  if (Number(t[n]) < e) {
    const o = wt(t.r, e, n);
    return o[0] === -1 / 0 ? [t.k, t.v] : o;
  }
  return wt(t.l, e, n);
}
function mt(t, e, n) {
  return j(t) ? Ln(e, n, 1) : e === t.k ? ot(t, { k: e, v: n }) : e < t.k ? dn(ot(t, { l: mt(t.l, e, n) })) : dn(ot(t, { r: mt(t.r, e, n) }));
}
function Kt() {
  return oe;
}
function ve(t, e, n) {
  if (j(t))
    return [];
  const o = wt(t, e)[0];
  return So(ze(t, o, n));
}
function Fe(t, e) {
  if (j(t)) return oe;
  const { k: n, l: o, r } = t;
  if (e === n) {
    if (j(o))
      return r;
    if (j(r))
      return o;
    {
      const [s, i] = zn(o);
      return ge(ot(t, { k: s, l: Fn(o), v: i }));
    }
  } else return e < n ? ge(ot(t, { l: Fe(o, e) })) : ge(ot(t, { r: Fe(r, e) }));
}
function _t(t) {
  return j(t) ? [] : [..._t(t.l), { k: t.k, v: t.v }, ..._t(t.r)];
}
function ze(t, e, n) {
  if (j(t))
    return [];
  const { k: o, l: r, r: s, v: i } = t;
  let l = [];
  return o > e && (l = l.concat(ze(r, e, n))), o >= e && o <= n && l.push({ k: o, v: i }), o <= n && (l = l.concat(ze(s, e, n))), l;
}
function ge(t) {
  const { l: e, lvl: n, r: o } = t;
  if (o.lvl >= n - 1 && e.lvl >= n - 1)
    return t;
  if (n > o.lvl + 1) {
    if (He(e))
      return Pn(ot(t, { lvl: n - 1 }));
    if (!j(e) && !j(e.r))
      return ot(e.r, {
        l: ot(e, { r: e.r.l }),
        lvl: n,
        r: ot(t, {
          l: e.r.r,
          lvl: n - 1
        })
      });
    throw new Error("Unexpected empty nodes");
  } else {
    if (He(t))
      return Le(ot(t, { lvl: n - 1 }));
    if (!j(o) && !j(o.l)) {
      const r = o.l, s = He(r) ? o.lvl - 1 : o.lvl;
      return ot(r, {
        l: ot(t, {
          lvl: n - 1,
          r: r.l
        }),
        lvl: r.lvl + 1,
        r: Le(ot(o, { l: r.r, lvl: s }))
      });
    } else
      throw new Error("Unexpected empty nodes");
  }
}
function ot(t, e) {
  return Ln(
    e.k !== void 0 ? e.k : t.k,
    e.v !== void 0 ? e.v : t.v,
    e.lvl !== void 0 ? e.lvl : t.lvl,
    e.l !== void 0 ? e.l : t.l,
    e.r !== void 0 ? e.r : t.r
  );
}
function Fn(t) {
  return j(t.r) ? t.l : ge(ot(t, { r: Fn(t.r) }));
}
function He(t) {
  return j(t) || t.lvl > t.r.lvl;
}
function zn(t) {
  return j(t.r) ? [t.k, t.v] : zn(t.r);
}
function Ln(t, e, n, o = oe, r = oe) {
  return { k: t, l: o, lvl: n, r, v: e };
}
function dn(t) {
  return Le(Pn(t));
}
function Pn(t) {
  const { l: e } = t;
  return !j(e) && e.lvl === t.lvl ? ot(e, { r: ot(t, { l: e.r }) }) : t;
}
function Le(t) {
  const { lvl: e, r: n } = t;
  return !j(n) && !j(n.r) && n.lvl === e && n.r.lvl === e ? ot(n, { l: ot(t, { r: n.l }), lvl: e + 1 }) : t;
}
function So(t) {
  return On(t, ({ k: e, v: n }) => ({ index: e, value: n }));
}
function Vn(t, e) {
  return !!(t && t.startIndex === e.startIndex && t.endIndex === e.endIndex);
}
function se(t, e) {
  return !!(t && t[0] === e[0] && t[1] === e[1]);
}
const Ge = U(
  () => ({ recalcInProgress: w(!1) }),
  [],
  { singleton: !0 }
);
function An(t, e, n) {
  return t[Se(t, e, n)];
}
function Se(t, e, n, o = 0) {
  let r = t.length - 1;
  for (; o <= r; ) {
    const s = Math.floor((o + r) / 2), i = t[s], l = n(i, e);
    if (l === 0)
      return s;
    if (l === -1) {
      if (r - o < 2)
        return s - 1;
      r = s - 1;
    } else {
      if (r === o)
        return s;
      o = s + 1;
    }
  }
  throw new Error(`Failed binary finding record in array - ${t.join(",")}, searched for ${e}`);
}
function xo(t, e, n, o) {
  const r = Se(t, e, o), s = Se(t, n, o, r);
  return t.slice(r, s + 1);
}
function Ct(t, e) {
  return Math.round(t.getBoundingClientRect()[e]);
}
function be(t) {
  return !j(t.groupOffsetTree);
}
function Ne({ index: t }, e) {
  return e === t ? 0 : e < t ? -1 : 1;
}
function To() {
  return {
    groupIndices: [],
    groupOffsetTree: Kt(),
    lastIndex: 0,
    lastOffset: 0,
    lastSize: 0,
    offsetTree: [],
    sizeTree: Kt()
  };
}
function wo(t, e) {
  let n = j(t) ? 0 : 1 / 0;
  for (const o of e) {
    const { endIndex: r, size: s, startIndex: i } = o;
    if (n = Math.min(n, i), j(t)) {
      t = mt(t, 0, s);
      continue;
    }
    const l = ve(t, i - 1, r + 1);
    if (l.some(Ho(o)))
      continue;
    let c = !1, d = !1;
    for (const { end: f, start: S, value: p } of l)
      c ? (r >= S || s === p) && (t = Fe(t, S)) : (d = p !== s, c = !0), f > r && r >= S && p !== s && (t = mt(t, r + 1, p));
    d && (t = mt(t, i, s));
  }
  return [t, n];
}
function Co(t) {
  return typeof t.groupIndex < "u";
}
function yo({ offset: t }, e) {
  return e === t ? 0 : e < t ? -1 : 1;
}
function ie(t, e, n) {
  if (e.length === 0)
    return 0;
  const { index: o, offset: r, size: s } = An(e, t, Ne), i = t - o, l = s * i + (i - 1) * n + r;
  return l > 0 ? l + n : l;
}
function Wn(t, e) {
  if (!be(e))
    return t;
  let n = 0;
  for (; e.groupIndices[n] <= t + n; )
    n++;
  return t + n;
}
function Mn(t, e, n) {
  if (Co(t))
    return e.groupIndices[t.groupIndex] + 1;
  {
    const o = t.index === "LAST" ? n : t.index;
    let r = Wn(o, e);
    return r = Math.max(0, r, Math.min(n, r)), r;
  }
}
function vo(t, e, n, o = 0) {
  return o > 0 && (e = Math.max(e, An(t, o, Ne).offset)), On(xo(t, e, n, yo), Eo);
}
function bo(t, [e, n, o, r]) {
  e.length > 0 && o("received item sizes", e, ht.DEBUG);
  const s = t.sizeTree;
  let i = s, l = 0;
  if (n.length > 0 && j(s) && e.length === 2) {
    const p = e[0].size, m = e[1].size;
    i = n.reduce((C, I) => mt(mt(C, I, p), I + 1, m), i);
  } else
    [i, l] = wo(i, e);
  if (i === s)
    return t;
  const { lastIndex: c, lastOffset: d, lastSize: f, offsetTree: S } = Pe(t.offsetTree, l, i, r);
  return {
    groupIndices: n,
    groupOffsetTree: n.reduce((p, m) => mt(p, m, ie(m, S, r)), Kt()),
    lastIndex: c,
    lastOffset: d,
    lastSize: f,
    offsetTree: S,
    sizeTree: i
  };
}
function Ro(t) {
  return _t(t).map(({ k: e, v: n }, o, r) => {
    const s = r[o + 1];
    return { endIndex: s ? s.k - 1 : 1 / 0, size: n, startIndex: e };
  });
}
function fn(t, e) {
  let n = 0, o = 0;
  for (; n < t; )
    n += e[o + 1] - e[o] - 1, o++;
  return o - (n === t ? 0 : 1);
}
function Pe(t, e, n, o) {
  let r = t, s = 0, i = 0, l = 0, c = 0;
  if (e !== 0) {
    c = Se(r, e - 1, Ne), l = r[c].offset;
    const f = wt(n, e - 1);
    s = f[0], i = f[1], r.length && r[c].size === wt(n, e)[1] && (c -= 1), r = r.slice(0, c + 1);
  } else
    r = [];
  for (const { start: d, value: f } of ve(n, e, 1 / 0)) {
    const S = d - s, p = S * i + l + S * o;
    r.push({
      index: d,
      offset: p,
      size: f
    }), s = d, l = p, i = f;
  }
  return {
    lastIndex: s,
    lastOffset: l,
    lastSize: i,
    offsetTree: r
  };
}
function Eo(t) {
  return { index: t.index, value: t };
}
function Ho(t) {
  const { endIndex: e, size: n, startIndex: o } = t;
  return (r) => r.start === o && (r.end === e || r.end === 1 / 0) && r.value === n;
}
const Bo = {
  offsetHeight: "height",
  offsetWidth: "width"
}, Ht = U(
  ([{ log: t }, { recalcInProgress: e }]) => {
    const n = $(), o = $(), r = ct(o, 0), s = $(), i = $(), l = w(0), c = w([]), d = w(void 0), f = w(void 0), S = w((h, a) => Ct(h, Bo[a])), p = w(void 0), m = w(0), C = To(), I = ct(
      x(n, G(c, t, m), bt(bo, C), Y()),
      C
    ), y = ct(
      x(
        c,
        Y(),
        bt((h, a) => ({ current: a, prev: h.current }), {
          current: [],
          prev: []
        }),
        H(({ prev: h }) => h)
      ),
      []
    );
    F(
      x(
        c,
        V((h) => h.length > 0),
        G(I, m),
        H(([h, a, R]) => {
          const k = h.reduce((O, z, P) => mt(O, z, ie(z, a.offsetTree, R) || P), Kt());
          return {
            ...a,
            groupIndices: h,
            groupOffsetTree: k
          };
        })
      ),
      I
    ), F(
      x(
        o,
        G(I),
        V(([h, { lastIndex: a }]) => h < a),
        H(([h, { lastIndex: a, lastSize: R }]) => [
          {
            endIndex: a,
            size: R,
            startIndex: h
          }
        ])
      ),
      n
    ), F(d, f);
    const g = ct(
      x(
        d,
        H((h) => h === void 0)
      ),
      !0
    );
    F(
      x(
        f,
        V((h) => h !== void 0 && j(lt(I).sizeTree)),
        H((h) => [{ endIndex: 0, size: h, startIndex: 0 }])
      ),
      n
    );
    const u = pt(
      x(
        n,
        G(I),
        bt(
          ({ sizes: h }, [a, R]) => ({
            changed: R !== h,
            sizes: R
          }),
          { changed: !1, sizes: C }
        ),
        H((h) => h.changed)
      )
    );
    K(
      x(
        l,
        bt(
          (h, a) => ({ diff: h.prev - a, prev: a }),
          { diff: 0, prev: 0 }
        ),
        H((h) => h.diff)
      ),
      (h) => {
        const { groupIndices: a } = lt(I);
        if (h > 0)
          M(e, !0), M(s, h + fn(h, a));
        else if (h < 0) {
          const R = lt(y);
          R.length > 0 && (h -= fn(-h, R)), M(i, h);
        }
      }
    ), K(x(l, G(t)), ([h, a]) => {
      h < 0 && a(
        "`firstItemIndex` prop should not be set to less than zero. If you don't know the total count, just use a very high value",
        { firstItemIndex: l },
        ht.ERROR
      );
    });
    const T = pt(s);
    F(
      x(
        s,
        G(I),
        H(([h, a]) => {
          const R = a.groupIndices.length > 0, k = [], O = a.lastSize;
          if (R) {
            const z = re(a.sizeTree, 0);
            let P = 0, D = 0;
            for (; P < h; ) {
              const B = a.groupIndices[D], q = a.groupIndices.length === D + 1 ? 1 / 0 : a.groupIndices[D + 1] - B - 1;
              k.push({
                endIndex: B,
                size: z,
                startIndex: B
              }), k.push({
                endIndex: B + 1 + q - 1,
                size: O,
                startIndex: B + 1
              }), D++, P += q + 1;
            }
            const J = _t(a.sizeTree);
            return P !== h && J.shift(), J.reduce(
              (B, { k: q, v: st }) => {
                let dt = B.ranges;
                return B.prevSize !== 0 && (dt = [
                  ...B.ranges,
                  {
                    endIndex: q + h - 1,
                    size: B.prevSize,
                    startIndex: B.prevIndex
                  }
                ]), {
                  prevIndex: q + h,
                  prevSize: st,
                  ranges: dt
                };
              },
              {
                prevIndex: h,
                prevSize: 0,
                ranges: k
              }
            ).ranges;
          }
          return _t(a.sizeTree).reduce(
            (z, { k: P, v: D }) => ({
              prevIndex: P + h,
              prevSize: D,
              ranges: [...z.ranges, { endIndex: P + h - 1, size: z.prevSize, startIndex: z.prevIndex }]
            }),
            {
              prevIndex: 0,
              prevSize: O,
              ranges: []
            }
          ).ranges;
        })
      ),
      n
    );
    const b = pt(
      x(
        i,
        G(I, m),
        H(([h, { offsetTree: a }, R]) => {
          const k = -h;
          return ie(k, a, R);
        })
      )
    );
    return F(
      x(
        i,
        G(I, m),
        H(([h, a, R]) => {
          if (a.groupIndices.length > 0) {
            if (j(a.sizeTree))
              return a;
            let O = Kt();
            const z = lt(y);
            let P = 0, D = 0, J = 0;
            for (; P < -h; ) {
              J = z[D];
              const B = z[D + 1] - J - 1;
              D++, P += B + 1;
            }
            if (O = _t(a.sizeTree).reduce((B, { k: q, v: st }) => mt(B, Math.max(0, q + h), st), O), P !== -h) {
              const B = re(a.sizeTree, J);
              O = mt(O, 0, B);
              const q = wt(a.sizeTree, -h + 1)[1];
              O = mt(O, 1, q);
            }
            return {
              ...a,
              sizeTree: O,
              ...Pe(a.offsetTree, 0, O, R)
            };
          } else {
            const O = _t(a.sizeTree).reduce((z, { k: P, v: D }) => mt(z, Math.max(0, P + h), D), Kt());
            return {
              ...a,
              sizeTree: O,
              ...Pe(a.offsetTree, 0, O, R)
            };
          }
        })
      ),
      I
    ), {
      beforeUnshiftWith: T,
      // input
      data: p,
      defaultItemSize: f,
      firstItemIndex: l,
      fixedItemSize: d,
      gap: m,
      groupIndices: c,
      itemSize: S,
      listRefresh: u,
      shiftWith: i,
      shiftWithOffset: b,
      sizeRanges: n,
      // output
      sizes: I,
      statefulTotalCount: r,
      totalCount: o,
      trackItemSizes: g,
      unshiftWith: s
    };
  },
  X(Pt, Ge),
  { singleton: !0 }
);
function ko(t) {
  return t.reduce(
    (e, n) => (e.groupIndices.push(e.totalCount), e.totalCount += n + 1, e),
    {
      groupIndices: [],
      totalCount: 0
    }
  );
}
const _n = U(
  ([{ groupIndices: t, sizes: e, totalCount: n }, { headerHeight: o, scrollTop: r }]) => {
    const s = $(), i = $(), l = pt(x(s, H(ko)));
    return F(
      x(
        l,
        H((c) => c.totalCount)
      ),
      n
    ), F(
      x(
        l,
        H((c) => c.groupIndices)
      ),
      t
    ), F(
      x(
        rt(r, e, o),
        V(([c, d]) => be(d)),
        H(([c, d, f]) => wt(d.groupOffsetTree, Math.max(c - f, 0), "v")[0]),
        Y(),
        H((c) => [c])
      ),
      i
    ), { groupCounts: s, topItemsIndexes: i };
  },
  X(Ht, at)
), Vt = U(
  ([{ log: t }]) => {
    const e = w(!1), n = pt(
      x(
        e,
        V((o) => o),
        Y()
      )
    );
    return K(e, (o) => {
      o && lt(t)("props updated", {}, ht.DEBUG);
    }), { didMount: n, propsReady: e };
  },
  X(Pt),
  { singleton: !0 }
), Oo = typeof document < "u" && "scrollBehavior" in document.documentElement.style;
function Gn(t) {
  const e = typeof t == "number" ? { index: t } : t;
  return e.align || (e.align = "start"), (!e.behavior || !Oo) && (e.behavior = "auto"), e.offset || (e.offset = 0), e;
}
const ce = U(
  ([
    { gap: t, listRefresh: e, sizes: n, totalCount: o },
    {
      fixedFooterHeight: r,
      fixedHeaderHeight: s,
      footerHeight: i,
      headerHeight: l,
      scrollingInProgress: c,
      scrollTo: d,
      smoothScrollTargetReached: f,
      viewportHeight: S
    },
    { log: p }
  ]) => {
    const m = $(), C = $(), I = w(0);
    let y = null, g = null, u = null;
    function T() {
      y && (y(), y = null), u && (u(), u = null), g && (clearTimeout(g), g = null), M(c, !1);
    }
    return F(
      x(
        m,
        G(n, S, o, I, l, i, p),
        G(t, s, r),
        H(
          ([
            [b, h, a, R, k, O, z, P],
            D,
            J,
            nt
          ]) => {
            const B = Gn(b), { align: q, behavior: st, offset: dt } = B, St = R - 1, ft = Mn(B, h, St);
            let ut = ie(ft, h.offsetTree, D) + O;
            q === "end" ? (ut += J + wt(h.sizeTree, ft)[1] - a + nt, ft === St && (ut += z)) : q === "center" ? ut += (J + wt(h.sizeTree, ft)[1] - a + nt) / 2 : ut -= k, dt && (ut += dt);
            const At = (xt) => {
              T(), xt ? (P("retrying to scroll to", { location: b }, ht.DEBUG), M(m, b)) : (M(C, !0), P("list did not change, scroll successful", {}, ht.DEBUG));
            };
            if (T(), st === "smooth") {
              let xt = !1;
              u = K(e, (Xt) => {
                xt = xt || Xt;
              }), y = Rt(f, () => {
                At(xt);
              });
            } else
              y = Rt(x(e, Fo(150)), At);
            return g = setTimeout(() => {
              T();
            }, 1200), M(c, !0), P("scrolling from index to", { behavior: st, index: ft, top: ut }, ht.DEBUG), { behavior: st, top: ut };
          }
        )
      ),
      d
    ), {
      scrollTargetReached: C,
      scrollToIndex: m,
      topListHeight: I
    };
  },
  X(Ht, at, Pt),
  { singleton: !0 }
);
function Fo(t) {
  return (e) => {
    const n = setTimeout(() => {
      e(!1);
    }, t);
    return (o) => {
      o && (e(!0), clearTimeout(n));
    };
  };
}
function De(t, e) {
  t == 0 ? e() : requestAnimationFrame(() => {
    De(t - 1, e);
  });
}
function $e(t, e) {
  const n = e - 1;
  return typeof t == "number" ? t : t.index === "LAST" ? n : t.index;
}
const ue = U(
  ([{ defaultItemSize: t, listRefresh: e, sizes: n }, { scrollTop: o }, { scrollTargetReached: r, scrollToIndex: s }, { didMount: i }]) => {
    const l = w(!0), c = w(0), d = w(!0);
    return F(
      x(
        i,
        G(c),
        V(([f, S]) => !!S),
        vt(!1)
      ),
      l
    ), F(
      x(
        i,
        G(c),
        V(([f, S]) => !!S),
        vt(!1)
      ),
      d
    ), K(
      x(
        rt(e, i),
        G(l, n, t, d),
        V(([[, f], S, { sizeTree: p }, m, C]) => f && (!j(p) || Ae(m)) && !S && !C),
        G(c)
      ),
      ([, f]) => {
        Rt(r, () => {
          M(d, !0);
        }), De(4, () => {
          Rt(o, () => {
            M(l, !0);
          }), M(s, f);
        });
      }
    ), {
      initialItemFinalLocationReached: d,
      initialTopMostItemIndex: c,
      scrolledToInitialItem: l
    };
  },
  X(Ht, at, ce, Vt),
  { singleton: !0 }
);
function Nn(t, e) {
  return Math.abs(t - e) < 1.01;
}
const le = "up", te = "down", zo = "none", Lo = {
  atBottom: !1,
  notAtBottomBecause: "NOT_SHOWING_LAST_ITEM",
  state: {
    offsetBottom: 0,
    scrollHeight: 0,
    scrollTop: 0,
    viewportHeight: 0
  }
}, Po = 0, ae = U(([{ footerHeight: t, headerHeight: e, scrollBy: n, scrollContainerState: o, scrollTop: r, viewportHeight: s }]) => {
  const i = w(!1), l = w(!0), c = $(), d = $(), f = w(4), S = w(Po), p = ct(
    x(
      un(x(A(r), qt(1), vt(!0)), x(A(r), qt(1), vt(!1), cn(100))),
      Y()
    ),
    !1
  ), m = ct(
    x(un(x(n, vt(!0)), x(n, vt(!1), cn(200))), Y()),
    !1
  );
  F(
    x(
      rt(A(r), A(S)),
      H(([u, T]) => u <= T),
      Y()
    ),
    l
  ), F(x(l, zt(50)), d);
  const C = pt(
    x(
      rt(o, A(s), A(e), A(t), A(f)),
      bt((u, [{ scrollHeight: T, scrollTop: b }, h, a, R, k]) => {
        const O = b + h - T > -k, z = {
          scrollHeight: T,
          scrollTop: b,
          viewportHeight: h
        };
        if (O) {
          let D, J;
          return b > u.state.scrollTop ? (D = "SCROLLED_DOWN", J = u.state.scrollTop - b) : (D = "SIZE_DECREASED", J = u.state.scrollTop - b || u.scrollTopDelta), {
            atBottom: !0,
            atBottomBecause: D,
            scrollTopDelta: J,
            state: z
          };
        }
        let P;
        return z.scrollHeight > u.state.scrollHeight ? P = "SIZE_INCREASED" : h < u.state.viewportHeight ? P = "VIEWPORT_HEIGHT_DECREASING" : b < u.state.scrollTop ? P = "SCROLLING_UPWARDS" : P = "NOT_FULLY_SCROLLED_TO_LAST_ITEM_BOTTOM", {
          atBottom: !1,
          notAtBottomBecause: P,
          state: z
        };
      }, Lo),
      Y((u, T) => u && u.atBottom === T.atBottom)
    )
  ), I = ct(
    x(
      o,
      bt(
        (u, { scrollHeight: T, scrollTop: b, viewportHeight: h }) => {
          if (Nn(u.scrollHeight, T))
            return {
              changed: !1,
              jump: 0,
              scrollHeight: T,
              scrollTop: b
            };
          {
            const a = T - (b + h) < 1;
            return u.scrollTop !== b && a ? {
              changed: !0,
              jump: u.scrollTop - b,
              scrollHeight: T,
              scrollTop: b
            } : {
              changed: !0,
              jump: 0,
              scrollHeight: T,
              scrollTop: b
            };
          }
        },
        { changed: !1, jump: 0, scrollHeight: 0, scrollTop: 0 }
      ),
      V((u) => u.changed),
      H((u) => u.jump)
    ),
    0
  );
  F(
    x(
      C,
      H((u) => u.atBottom)
    ),
    i
  ), F(x(i, zt(50)), c);
  const y = w(te);
  F(
    x(
      o,
      H(({ scrollTop: u }) => u),
      Y(),
      bt(
        (u, T) => lt(m) ? { direction: u.direction, prevScrollTop: T } : { direction: T < u.prevScrollTop ? le : te, prevScrollTop: T },
        { direction: te, prevScrollTop: 0 }
      ),
      H((u) => u.direction)
    ),
    y
  ), F(x(o, zt(50), vt(zo)), y);
  const g = w(0);
  return F(
    x(
      p,
      V((u) => !u),
      vt(0)
    ),
    g
  ), F(
    x(
      r,
      zt(100),
      G(p),
      V(([u, T]) => !!T),
      bt(([u, T], [b]) => [T, b], [0, 0]),
      H(([u, T]) => T - u)
    ),
    g
  ), {
    atBottomState: C,
    atBottomStateChange: c,
    atBottomThreshold: f,
    atTopStateChange: d,
    atTopThreshold: S,
    isAtBottom: i,
    isAtTop: l,
    isScrolling: p,
    lastJumpDueToItemResize: I,
    scrollDirection: y,
    scrollVelocity: g
  };
}, X(at)), xe = "top", Te = "bottom", mn = "none";
function pn(t, e, n) {
  return typeof t == "number" ? n === le && e === xe || n === te && e === Te ? t : 0 : n === le ? e === xe ? t.main : t.reverse : e === Te ? t.main : t.reverse;
}
function hn(t, e) {
  var n;
  return typeof t == "number" ? t : (n = t[e]) != null ? n : 0;
}
const Ue = U(
  ([{ deviation: t, fixedHeaderHeight: e, headerHeight: n, scrollTop: o, viewportHeight: r }]) => {
    const s = $(), i = w(0), l = w(0), c = w(0), d = ct(
      x(
        rt(
          A(o),
          A(r),
          A(n),
          A(s, se),
          A(c),
          A(i),
          A(e),
          A(t),
          A(l)
        ),
        H(
          ([
            f,
            S,
            p,
            [m, C],
            I,
            y,
            g,
            u,
            T
          ]) => {
            const b = f - u, h = y + g, a = Math.max(p - b, 0);
            let R = mn;
            const k = hn(T, xe), O = hn(T, Te);
            return m -= u, m += p + g, C += p + g, C -= u, m > f + h - k && (R = le), C < f - a + S + O && (R = te), R !== mn ? [
              Math.max(b - p - pn(I, xe, R) - k, 0),
              b - a - g + S + pn(I, Te, R) + O
            ] : null;
          }
        ),
        V((f) => f != null),
        Y(se)
      ),
      [0, 0]
    );
    return {
      increaseViewportBy: l,
      // input
      listBoundary: s,
      overscan: c,
      topListHeight: i,
      // output
      visibleRange: d
    };
  },
  X(at),
  { singleton: !0 }
);
function Vo(t, e, n) {
  if (be(e)) {
    const o = Wn(t, e);
    return [
      { index: wt(e.groupOffsetTree, o)[0], offset: 0, size: 0 },
      { data: n == null ? void 0 : n[0], index: o, offset: 0, size: 0 }
    ];
  }
  return [{ data: n == null ? void 0 : n[0], index: t, offset: 0, size: 0 }];
}
const Be = {
  bottom: 0,
  firstItemIndex: 0,
  items: [],
  offsetBottom: 0,
  offsetTop: 0,
  top: 0,
  topItems: [],
  topListHeight: 0,
  totalCount: 0
};
function Ie(t, e, n, o, r, s) {
  const { lastIndex: i, lastOffset: l, lastSize: c } = r;
  let d = 0, f = 0;
  if (t.length > 0) {
    d = t[0].offset;
    const I = t[t.length - 1];
    f = I.offset + I.size;
  }
  const S = n - i, p = l + S * c + (S - 1) * o, m = d, C = p - f;
  return {
    bottom: f,
    firstItemIndex: s,
    items: gn(t, r, s),
    offsetBottom: C,
    offsetTop: d,
    top: m,
    topItems: gn(e, r, s),
    topListHeight: e.reduce((I, y) => y.size + I, 0),
    totalCount: n
  };
}
function Dn(t, e, n, o, r, s) {
  let i = 0;
  if (n.groupIndices.length > 0)
    for (const f of n.groupIndices) {
      if (f - i >= t)
        break;
      i++;
    }
  const l = t + i, c = $e(e, l), d = Array.from({ length: l }).map((f, S) => ({
    data: s[S + c],
    index: S + c,
    offset: 0,
    size: 0
  }));
  return Ie(d, [], l, r, n, o);
}
function gn(t, e, n) {
  if (t.length === 0)
    return [];
  if (!be(e))
    return t.map((d) => ({ ...d, index: d.index + n, originalIndex: d.index }));
  const o = t[0].index, r = t[t.length - 1].index, s = [], i = ve(e.groupOffsetTree, o, r);
  let l, c = 0;
  for (const d of t) {
    (!l || l.end < d.index) && (l = i.shift(), c = e.groupIndices.indexOf(l.start));
    let f;
    d.index === l.start ? f = {
      index: c,
      type: "group"
    } : f = {
      groupIndex: c,
      index: d.index - (c + 1) + n
    }, s.push({
      ...f,
      data: d.data,
      offset: d.offset,
      originalIndex: d.index,
      size: d.size
    });
  }
  return s;
}
const Nt = U(
  ([
    { data: t, firstItemIndex: e, gap: n, sizes: o, totalCount: r },
    s,
    { listBoundary: i, topListHeight: l, visibleRange: c },
    { initialTopMostItemIndex: d, scrolledToInitialItem: f },
    { topListHeight: S },
    p,
    { didMount: m },
    { recalcInProgress: C }
  ]) => {
    const I = w([]), y = w(0), g = $();
    F(s.topItemsIndexes, I);
    const u = ct(
      x(
        rt(
          m,
          C,
          A(c, se),
          A(r),
          A(o),
          A(d),
          f,
          A(I),
          A(e),
          A(n),
          t
        ),
        V(([a, R, , k, , , , , , , O]) => {
          const z = O && O.length !== k;
          return a && !R && !z;
        }),
        H(
          ([
            ,
            ,
            [a, R],
            k,
            O,
            z,
            P,
            D,
            J,
            nt,
            B
          ]) => {
            const q = O, { offsetTree: st, sizeTree: dt } = q, St = lt(y);
            if (k === 0)
              return { ...Be, totalCount: k };
            if (a === 0 && R === 0)
              return St === 0 ? { ...Be, totalCount: k } : Dn(St, z, O, J, nt, B || []);
            if (j(dt))
              return St > 0 ? null : Ie(
                Vo($e(z, k), q, B),
                [],
                k,
                nt,
                q,
                J
              );
            const ft = [];
            if (D.length > 0) {
              const Wt = D[0], yt = D[D.length - 1];
              let Bt = 0;
              for (const v of ve(dt, Wt, yt)) {
                const N = v.value, Q = Math.max(v.start, Wt), it = Math.min(v.end, yt);
                for (let tt = Q; tt <= it; tt++)
                  ft.push({ data: B == null ? void 0 : B[tt], index: tt, offset: Bt, size: N }), Bt += N;
              }
            }
            if (!P)
              return Ie([], ft, k, nt, q, J);
            const ut = D.length > 0 ? D[D.length - 1] + 1 : 0, At = vo(st, a, R, ut);
            if (At.length === 0)
              return null;
            const xt = k - 1, Xt = ye([], (Wt) => {
              for (const yt of At) {
                const Bt = yt.value;
                let v = Bt.offset, N = yt.start;
                const Q = Bt.size;
                if (Bt.offset < a) {
                  N += Math.floor((a - Bt.offset + nt) / (Q + nt));
                  const tt = N - yt.start;
                  v += tt * Q + tt * nt;
                }
                N < ut && (v += (ut - N) * Q, N = ut);
                const it = Math.min(yt.end, xt);
                for (let tt = N; tt <= it && !(v >= R); tt++)
                  Wt.push({ data: B == null ? void 0 : B[tt], index: tt, offset: v, size: Q }), v += Q + nt;
              }
            });
            return Ie(Xt, ft, k, nt, q, J);
          }
        ),
        //@ts-expect-error filter needs to be fixed
        V((a) => a !== null),
        Y()
      ),
      Be
    );
    F(
      x(
        t,
        V(Ae),
        H((a) => a == null ? void 0 : a.length)
      ),
      r
    ), F(
      x(
        u,
        H((a) => a.topListHeight)
      ),
      S
    ), F(S, l), F(
      x(
        u,
        H((a) => [a.top, a.bottom])
      ),
      i
    ), F(
      x(
        u,
        H((a) => a.items)
      ),
      g
    );
    const T = pt(
      x(
        u,
        V(({ items: a }) => a.length > 0),
        G(r, t),
        V(([{ items: a }, R]) => a[a.length - 1].originalIndex === R - 1),
        H(([, a, R]) => [a - 1, R]),
        Y(se),
        H(([a]) => a)
      )
    ), b = pt(
      x(
        u,
        zt(200),
        V(({ items: a, topItems: R }) => a.length > 0 && a[0].originalIndex === R.length),
        H(({ items: a }) => a[0].index),
        Y()
      )
    ), h = pt(
      x(
        u,
        V(({ items: a }) => a.length > 0),
        H(({ items: a }) => {
          let R = 0, k = a.length - 1;
          for (; a[R].type === "group" && R < k; )
            R++;
          for (; a[k].type === "group" && k > R; )
            k--;
          return {
            endIndex: a[k].index,
            startIndex: a[R].index
          };
        }),
        Y(Vn)
      )
    );
    return { endReached: T, initialItemCount: y, itemsRendered: g, listState: u, rangeChanged: h, startReached: b, topItemsIndexes: I, ...p };
  },
  X(
    Ht,
    _n,
    Ue,
    ue,
    ce,
    ae,
    Vt,
    Ge
  ),
  { singleton: !0 }
), $n = U(
  ([{ fixedFooterHeight: t, fixedHeaderHeight: e, footerHeight: n, headerHeight: o }, { listState: r }]) => {
    const s = $(), i = ct(
      x(
        rt(n, t, o, e, r),
        H(([l, c, d, f, S]) => l + c + d + f + S.offsetBottom + S.bottom)
      ),
      0
    );
    return F(A(i), s), { totalListHeight: i, totalListHeightChanged: s };
  },
  X(at, Nt),
  { singleton: !0 }
), Ao = U(
  ([{ viewportHeight: t }, { totalListHeight: e }]) => {
    const n = w(!1), o = ct(
      x(
        rt(n, t, e),
        V(([r]) => r),
        H(([, r, s]) => Math.max(0, r - s)),
        zt(0),
        Y()
      ),
      0
    );
    return { alignToBottom: n, paddingTopAddition: o };
  },
  X(at, $n),
  { singleton: !0 }
);
function In(t) {
  return t ? t === "smooth" ? "smooth" : "auto" : !1;
}
const Wo = (t, e) => typeof t == "function" ? In(t(e)) : e && In(t), Mo = U(
  ([
    { listRefresh: t, totalCount: e },
    { atBottomState: n, isAtBottom: o },
    { scrollToIndex: r },
    { scrolledToInitialItem: s },
    { didMount: i, propsReady: l },
    { log: c },
    { scrollingInProgress: d }
  ]) => {
    const f = w(!1), S = $();
    let p = null;
    function m(I) {
      M(r, {
        align: "end",
        behavior: I,
        index: "LAST"
      });
    }
    K(
      x(
        rt(x(A(e), qt(1)), i),
        G(A(f), o, s, d),
        H(([[I, y], g, u, T, b]) => {
          let h = y && T, a = "auto";
          return h && (a = Wo(g, u || b), h = h && !!a), { followOutputBehavior: a, shouldFollow: h, totalCount: I };
        }),
        V(({ shouldFollow: I }) => I)
      ),
      ({ followOutputBehavior: I, totalCount: y }) => {
        p && (p(), p = null), p = Rt(t, () => {
          lt(c)("following output to ", { totalCount: y }, ht.DEBUG), m(I), p = null;
        });
      }
    );
    function C(I) {
      const y = Rt(n, (g) => {
        I && !g.atBottom && g.notAtBottomBecause === "SIZE_INCREASED" && !p && (lt(c)("scrolling to bottom due to increased size", {}, ht.DEBUG), m("auto"));
      });
      setTimeout(y, 100);
    }
    return K(
      x(
        rt(A(f), e, l),
        V(([I, , y]) => I && y),
        bt(
          ({ value: I }, [, y]) => ({ refreshed: I === y, value: y }),
          { refreshed: !1, value: 0 }
        ),
        V(({ refreshed: I }) => I),
        G(f, e)
      ),
      ([, I]) => {
        lt(s) && C(I !== !1);
      }
    ), K(S, () => {
      C(lt(f) !== !1);
    }), K(rt(A(f), n), ([I, y]) => {
      I && !y.atBottom && y.notAtBottomBecause === "VIEWPORT_HEIGHT_DECREASING" && m("auto");
    }), { autoscrollToBottom: S, followOutput: f };
  },
  X(Ht, ae, ce, ue, Vt, Pt, at)
), _o = U(
  ([{ data: t, firstItemIndex: e, gap: n, sizes: o }, { initialTopMostItemIndex: r }, { initialItemCount: s, listState: i }, { didMount: l }]) => (F(
    x(
      l,
      G(s),
      V(([, c]) => c !== 0),
      G(r, o, e, n, t),
      H(([[, c], d, f, S, p, m = []]) => Dn(c, d, f, S, p, m))
    ),
    i
  ), {}),
  X(Ht, ue, Nt, Vt),
  { singleton: !0 }
), Go = U(
  ([{ didMount: t }, { scrollTo: e }, { listState: n }]) => {
    const o = w(0);
    return K(
      x(
        t,
        G(o),
        V(([, r]) => r !== 0),
        H(([, r]) => ({ top: r }))
      ),
      (r) => {
        Rt(
          x(
            n,
            qt(1),
            V((s) => s.items.length > 1)
          ),
          () => {
            requestAnimationFrame(() => {
              M(e, r);
            });
          }
        );
      }
    ), {
      initialScrollTop: o
    };
  },
  X(Vt, at, Nt),
  { singleton: !0 }
), No = ({
  itemBottom: t,
  itemTop: e,
  locationParams: { align: n, behavior: o, ...r },
  viewportBottom: s,
  viewportTop: i
}) => e < i ? { ...r, align: n != null ? n : "start", behavior: o } : t > s ? { ...r, align: n != null ? n : "end", behavior: o } : null, Do = U(
  ([
    { gap: t, sizes: e, totalCount: n },
    { fixedFooterHeight: o, fixedHeaderHeight: r, headerHeight: s, scrollingInProgress: i, scrollTop: l, viewportHeight: c },
    { scrollToIndex: d }
  ]) => {
    const f = $();
    return F(
      x(
        f,
        G(e, c, n, s, r, o, l),
        G(t),
        H(([[S, p, m, C, I, y, g, u], T]) => {
          const { align: b, behavior: h, calculateViewLocation: a = No, done: R, ...k } = S, O = Mn(S, p, C - 1), z = ie(O, p.offsetTree, T) + I + y, P = z + wt(p.sizeTree, O)[1], D = u + y, J = u + m - g, nt = a({
            itemBottom: P,
            itemTop: z,
            locationParams: { align: b, behavior: h, ...k },
            viewportBottom: J,
            viewportTop: D
          });
          return nt ? R && Rt(
            x(
              i,
              V((B) => !B),
              // skips the initial publish of false, and the cleanup call.
              // but if scrollingInProgress is true, we skip the initial publish.
              qt(lt(i) ? 1 : 2)
            ),
            R
          ) : R && R(), nt;
        }),
        V((S) => S !== null)
      ),
      d
    ), {
      scrollIntoView: f
    };
  },
  X(Ht, at, ce, Nt, Pt),
  { singleton: !0 }
), Un = U(
  ([{ scrollVelocity: t }]) => {
    const e = w(!1), n = $(), o = w(!1);
    return F(
      x(
        t,
        G(o, e, n),
        V(([r, s]) => !!s),
        H(([r, s, i, l]) => {
          const { enter: c, exit: d } = s;
          if (i) {
            if (d(r, l))
              return !1;
          } else if (c(r, l))
            return !0;
          return i;
        }),
        Y()
      ),
      e
    ), K(
      x(rt(e, t, n), G(o)),
      ([[r, s, i], l]) => {
        r && l && l.change && l.change(s, i);
      }
    ), { isSeeking: e, scrollSeekConfiguration: o, scrollSeekRangeChanged: n, scrollVelocity: t };
  },
  X(ae),
  { singleton: !0 }
), Ke = U(([{ scrollContainerState: t, scrollTo: e }]) => {
  const n = $(), o = $(), r = $(), s = w(!1), i = w(void 0);
  return F(
    x(
      rt(n, o),
      H(([{ scrollHeight: l, scrollTop: c, viewportHeight: d }, { offsetTop: f }]) => ({
        scrollHeight: l,
        scrollTop: Math.max(0, c - f),
        viewportHeight: d
      }))
    ),
    t
  ), F(
    x(
      e,
      G(o),
      H(([l, { offsetTop: c }]) => ({
        ...l,
        top: l.top + c
      }))
    ),
    r
  ), {
    customScrollParent: i,
    // config
    useWindowScroll: s,
    // input
    windowScrollContainerState: n,
    // signals
    windowScrollTo: r,
    windowViewportRect: o
  };
}, X(at)), $o = U(
  ([
    { sizeRanges: t, sizes: e },
    { headerHeight: n, scrollTop: o },
    { initialTopMostItemIndex: r },
    { didMount: s },
    { useWindowScroll: i, windowScrollContainerState: l, windowViewportRect: c }
  ]) => {
    const d = $(), f = w(void 0), S = w(null), p = w(null);
    return F(l, S), F(c, p), K(
      x(
        d,
        G(e, o, i, S, p, n)
      ),
      ([m, C, I, y, g, u, T]) => {
        const b = Ro(C.sizeTree);
        y && g !== null && u !== null && (I = g.scrollTop - u.offsetTop), I -= T, m({ ranges: b, scrollTop: I });
      }
    ), F(x(f, V(Ae), H(Uo)), r), F(
      x(
        s,
        G(f),
        V(([, m]) => m !== void 0),
        Y(),
        H(([, m]) => m.ranges)
      ),
      t
    ), {
      getState: d,
      restoreStateFrom: f
    };
  },
  X(Ht, at, ue, Vt, Ke)
);
function Uo(t) {
  return { align: "start", index: 0, offset: t.scrollTop };
}
const Ko = U(([{ topItemsIndexes: t }]) => {
  const e = w(0);
  return F(
    x(
      e,
      V((n) => n >= 0),
      H((n) => Array.from({ length: n }).map((o, r) => r))
    ),
    t
  ), { topItemCount: e };
}, X(Nt));
function Kn(t) {
  let e = !1, n;
  return () => (e || (e = !0, n = t()), n);
}
const jo = Kn(() => /iP(ad|od|hone)/i.test(navigator.userAgent) && /WebKit/i.test(navigator.userAgent)), qo = U(
  ([
    { deviation: t, scrollBy: e, scrollingInProgress: n, scrollTop: o },
    { isAtBottom: r, isScrolling: s, lastJumpDueToItemResize: i, scrollDirection: l },
    { listState: c },
    { beforeUnshiftWith: d, gap: f, shiftWithOffset: S, sizes: p },
    { log: m },
    { recalcInProgress: C }
  ]) => {
    const I = pt(
      x(
        c,
        G(i),
        bt(
          ([, g, u, T], [{ bottom: b, items: h, offsetBottom: a, totalCount: R }, k]) => {
            const O = b + a;
            let z = 0;
            return u === R && g.length > 0 && h.length > 0 && (h[0].originalIndex === 0 && g[0].originalIndex === 0 || (z = O - T, z !== 0 && (z += k))), [z, h, R, O];
          },
          [0, [], 0, 0]
        ),
        V(([g]) => g !== 0),
        G(o, l, n, r, m, C),
        V(([, g, u, T, , , b]) => !b && !T && g !== 0 && u === le),
        H(([[g], , , , , u]) => (u("Upward scrolling compensation", { amount: g }, ht.DEBUG), g))
      )
    );
    function y(g) {
      g > 0 ? (M(e, { behavior: "auto", top: -g }), M(t, 0)) : (M(t, 0), M(e, { behavior: "auto", top: -g }));
    }
    return K(x(I, G(t, s)), ([g, u, T]) => {
      T && jo() ? M(t, u - g) : y(-g);
    }), K(
      x(
        rt(ct(s, !1), t, C),
        V(([g, u, T]) => !g && !T && u !== 0),
        H(([g, u]) => u),
        zt(1)
      ),
      y
    ), F(
      x(
        S,
        H((g) => ({ top: -g }))
      ),
      e
    ), K(
      x(
        d,
        G(p, f),
        H(([g, { groupIndices: u, lastSize: T, sizeTree: b }, h]) => {
          function a(R) {
            return R * (T + h);
          }
          if (u.length === 0)
            return a(g);
          {
            let R = 0;
            const k = re(b, 0);
            let O = 0, z = 0;
            for (; O < g; ) {
              O++, R += k;
              let P = u.length === z + 1 ? 1 / 0 : u[z + 1] - u[z] - 1;
              O + P > g && (R -= k, P = g - O + 1), O += P, R += a(P), z++;
            }
            return R;
          }
        })
      ),
      (g) => {
        M(t, g), requestAnimationFrame(() => {
          M(e, { top: g }), requestAnimationFrame(() => {
            M(t, 0), M(C, !1);
          });
        });
      }
    ), { deviation: t };
  },
  X(at, ae, Nt, Ht, Pt, Ge)
), Yo = U(
  ([
    t,
    e,
    n,
    o,
    r,
    s,
    i,
    l,
    c,
    d
  ]) => ({
    ...t,
    ...e,
    ...n,
    ...o,
    ...r,
    ...s,
    ...i,
    ...l,
    ...c,
    ...d
  }),
  X(
    Ue,
    _o,
    Vt,
    Un,
    $n,
    Go,
    Ao,
    Ke,
    Do,
    Pt
  )
), jn = U(
  ([
    {
      data: t,
      defaultItemSize: e,
      firstItemIndex: n,
      fixedItemSize: o,
      gap: r,
      groupIndices: s,
      itemSize: i,
      sizeRanges: l,
      sizes: c,
      statefulTotalCount: d,
      totalCount: f,
      trackItemSizes: S
    },
    { initialItemFinalLocationReached: p, initialTopMostItemIndex: m, scrolledToInitialItem: C },
    I,
    y,
    g,
    { listState: u, topItemsIndexes: T, ...b },
    { scrollToIndex: h },
    a,
    { topItemCount: R },
    { groupCounts: k },
    O
  ]) => (F(b.rangeChanged, O.scrollSeekRangeChanged), F(
    x(
      O.windowViewportRect,
      H((z) => z.visibleHeight)
    ),
    I.viewportHeight
  ), {
    data: t,
    defaultItemHeight: e,
    firstItemIndex: n,
    fixedItemHeight: o,
    gap: r,
    groupCounts: k,
    initialItemFinalLocationReached: p,
    initialTopMostItemIndex: m,
    scrolledToInitialItem: C,
    sizeRanges: l,
    topItemCount: R,
    topItemsIndexes: T,
    // input
    totalCount: f,
    ...g,
    groupIndices: s,
    itemSize: i,
    listState: u,
    scrollToIndex: h,
    // output
    statefulTotalCount: d,
    trackItemSizes: S,
    // exported from stateFlagsSystem
    ...b,
    // the bag of IO from featureGroup1System
    ...O,
    ...I,
    sizes: c,
    ...y
  }),
  X(
    Ht,
    ue,
    at,
    $o,
    Mo,
    Nt,
    ce,
    qo,
    Ko,
    _n,
    Yo
  )
);
function Zo(t, e) {
  const n = {}, o = {};
  let r = 0;
  const s = t.length;
  for (; r < s; )
    o[t[r]] = 1, r += 1;
  for (const i in e)
    Object.hasOwn(o, i) || (n[i] = e[i]);
  return n;
}
const pe = typeof document < "u" ? react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_1__.useEffect;
function je(t, e, n) {
  const o = Object.keys(e.required || {}), r = Object.keys(e.optional || {}), s = Object.keys(e.methods || {}), i = Object.keys(e.events || {}), l = react__WEBPACK_IMPORTED_MODULE_1__.createContext({});
  function c(g, u) {
    g.propsReady && M(g.propsReady, !1);
    for (const T of o) {
      const b = g[e.required[T]];
      M(b, u[T]);
    }
    for (const T of r)
      if (T in u) {
        const b = g[e.optional[T]];
        M(b, u[T]);
      }
    g.propsReady && M(g.propsReady, !0);
  }
  function d(g) {
    return s.reduce((u, T) => (u[T] = (b) => {
      const h = g[e.methods[T]];
      M(h, b);
    }, u), {});
  }
  function f(g) {
    return i.reduce((u, T) => (u[T] = fo(g[e.events[T]]), u), {});
  }
  const S = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((g, u) => {
    const { children: T, ...b } = g, [h] = react__WEBPACK_IMPORTED_MODULE_1__.useState(() => ye(po(t), (k) => {
      c(k, b);
    })), [a] = react__WEBPACK_IMPORTED_MODULE_1__.useState(ln(f, h));
    pe(() => {
      for (const k of i)
        k in b && K(a[k], b[k]);
      return () => {
        Object.values(a).map(We);
      };
    }, [b, a, h]), pe(() => {
      c(h, b);
    }), react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle(u, sn(d(h)));
    const R = n;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(l.Provider, { value: h, children: n ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(R, { ...Zo([...o, ...r, ...i], b), children: T }) : T });
  }), p = (g) => react__WEBPACK_IMPORTED_MODULE_1__.useCallback(Hn(M, react__WEBPACK_IMPORTED_MODULE_1__.useContext(l)[g]), [g]), m = (g) => {
    const T = react__WEBPACK_IMPORTED_MODULE_1__.useContext(l)[g], b = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(
      (h) => K(T, h),
      [T]
    );
    return react__WEBPACK_IMPORTED_MODULE_1__.useSyncExternalStore(
      b,
      () => lt(T),
      () => lt(T)
    );
  }, C = (g) => {
    const T = react__WEBPACK_IMPORTED_MODULE_1__.useContext(l)[g], [b, h] = react__WEBPACK_IMPORTED_MODULE_1__.useState(ln(lt, T));
    return pe(
      () => K(T, (a) => {
        a !== b && h(sn(a));
      }),
      [T, b]
    ), b;
  }, I = react__WEBPACK_IMPORTED_MODULE_1__.version.startsWith("18") ? m : C;
  return {
    Component: S,
    useEmitter: (g, u) => {
      const b = react__WEBPACK_IMPORTED_MODULE_1__.useContext(l)[g];
      pe(() => K(b, u), [u, b]);
    },
    useEmitterValue: I,
    usePublisher: p
  };
}
const Re = react__WEBPACK_IMPORTED_MODULE_1__.createContext(void 0), qn = react__WEBPACK_IMPORTED_MODULE_1__.createContext(void 0), Yn = typeof document < "u" ? react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_1__.useEffect;
function Zn(t, e, n, o = Gt, r, s) {
  const i = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), l = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), c = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), d = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(
    (p) => {
      const m = p.target, C = m === window || m === document, I = s ? C ? window.pageXOffset || document.documentElement.scrollLeft : m.scrollLeft : C ? window.pageYOffset || document.documentElement.scrollTop : m.scrollTop, y = s ? C ? document.documentElement.scrollWidth : m.scrollWidth : C ? document.documentElement.scrollHeight : m.scrollHeight, g = s ? C ? window.innerWidth : m.offsetWidth : C ? window.innerHeight : m.offsetHeight, u = () => {
        t({
          scrollHeight: y,
          scrollTop: Math.max(I, 0),
          viewportHeight: g
        });
      };
      p.suppressFlushSync ? u() : react_dom__WEBPACK_IMPORTED_MODULE_2__.flushSync(u), l.current !== null && (I === l.current || I <= 0 || I === y - g) && (l.current = null, e(!0), c.current && (clearTimeout(c.current), c.current = null));
    },
    [t, e]
  );
  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    const p = r || i.current;
    return o(r || i.current), d({ suppressFlushSync: !0, target: p }), p.addEventListener("scroll", d, { passive: !0 }), () => {
      o(null), p.removeEventListener("scroll", d);
    };
  }, [i, d, n, o, r]);
  function f(p) {
    const m = i.current;
    if (!m || (s ? "offsetWidth" in m && m.offsetWidth === 0 : "offsetHeight" in m && m.offsetHeight === 0))
      return;
    const C = p.behavior === "smooth";
    let I, y, g;
    m === window ? (y = Math.max(
      Ct(document.documentElement, s ? "width" : "height"),
      s ? document.documentElement.scrollWidth : document.documentElement.scrollHeight
    ), I = s ? window.innerWidth : window.innerHeight, g = s ? document.documentElement.scrollLeft : document.documentElement.scrollTop) : (y = m[s ? "scrollWidth" : "scrollHeight"], I = Ct(m, s ? "width" : "height"), g = m[s ? "scrollLeft" : "scrollTop"]);
    const u = y - I;
    if (p.top = Math.ceil(Math.max(Math.min(u, p.top), 0)), Nn(I, y) || p.top === g) {
      t({ scrollHeight: y, scrollTop: g, viewportHeight: I }), C && e(!0);
      return;
    }
    C ? (l.current = p.top, c.current && clearTimeout(c.current), c.current = setTimeout(() => {
      c.current = null, l.current = null, e(!0);
    }, 1e3)) : l.current = null, s && (p = { behavior: p.behavior, left: p.top }), m.scrollTo(p);
  }
  function S(p) {
    s && (p = { behavior: p.behavior, left: p.top }), i.current.scrollBy(p);
  }
  return { scrollByCallback: S, scrollerRef: i, scrollToCallback: f };
}
const ke = "-webkit-sticky", Sn = "sticky", Xn = Kn(() => {
  if (typeof document > "u")
    return Sn;
  const t = document.createElement("div");
  return t.style.position = ke, t.style.position === ke ? ke : Sn;
});
function qe(t) {
  return t;
}
const Xo = /* @__PURE__ */ U(() => {
  const t = w((c) => `Item ${c}`), e = w(null), n = w((c) => `Group ${c}`), o = w({}), r = w(qe), s = w("div"), i = w(Gt), l = (c, d = null) => ct(
    x(
      o,
      H((f) => f[c]),
      Y()
    ),
    d
  );
  return {
    components: o,
    computeItemKey: r,
    context: e,
    EmptyPlaceholder: l("EmptyPlaceholder"),
    FooterComponent: l("Footer"),
    GroupComponent: l("Group", "div"),
    groupContent: n,
    HeaderComponent: l("Header"),
    HeaderFooterTag: s,
    ItemComponent: l("Item", "div"),
    itemContent: t,
    ListComponent: l("List", "div"),
    ScrollerComponent: l("Scroller", "div"),
    scrollerRef: i,
    ScrollSeekPlaceholder: l("ScrollSeekPlaceholder"),
    TopItemListComponent: l("TopItemList")
  };
}), Jo = /* @__PURE__ */ U(
  ([t, e]) => ({ ...t, ...e }),
  X(jn, Xo)
), Qo = ({ height: t }) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { style: { height: t } }), tr = { overflowAnchor: "none", position: Xn(), zIndex: 1 }, Jn = { overflowAnchor: "none" }, er = { ...Jn, display: "inline-block", height: "100%" }, xn = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.memo(function({ showTopList: e = !1 }) {
  const n = W("listState"), o = gt("sizeRanges"), r = W("useWindowScroll"), s = W("customScrollParent"), i = gt("windowScrollContainerState"), l = gt("scrollContainerState"), c = s || r ? i : l, d = W("itemContent"), f = W("context"), S = W("groupContent"), p = W("trackItemSizes"), m = W("itemSize"), C = W("log"), I = gt("gap"), y = W("horizontalDirection"), { callbackRef: g } = kn(
    o,
    m,
    p,
    e ? Gt : c,
    C,
    I,
    s,
    y,
    W("skipAnimationFrameInResizeObserver")
  ), [u, T] = react__WEBPACK_IMPORTED_MODULE_1__.useState(0);
  Xe("deviation", (B) => {
    u !== B && T(B);
  });
  const b = W("EmptyPlaceholder"), h = W("ScrollSeekPlaceholder") || Qo, a = W("ListComponent"), R = W("ItemComponent"), k = W("GroupComponent"), O = W("computeItemKey"), z = W("isSeeking"), P = W("groupIndices").length > 0, D = W("alignToBottom"), J = W("initialItemFinalLocationReached"), nt = e ? {} : {
    boxSizing: "border-box",
    ...y ? {
      display: "inline-block",
      height: "100%",
      marginLeft: u !== 0 ? u : D ? "auto" : 0,
      paddingLeft: n.offsetTop,
      paddingRight: n.offsetBottom,
      whiteSpace: "nowrap"
    } : {
      marginTop: u !== 0 ? u : D ? "auto" : 0,
      paddingBottom: n.offsetBottom,
      paddingTop: n.offsetTop
    },
    ...J ? {} : { visibility: "hidden" }
  };
  return !e && n.totalCount === 0 && b ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(b, { ...Z(b, f) }) : /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    a,
    {
      ...Z(a, f),
      "data-testid": e ? "virtuoso-top-item-list" : "virtuoso-item-list",
      ref: g,
      style: nt,
      children: (e ? n.topItems : n.items).map((B) => {
        const q = B.originalIndex, st = O(q + n.firstItemIndex, B.data, f);
        return z ? /* @__PURE__ */ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(
          h,
          {
            ...Z(h, f),
            height: B.size,
            index: B.index,
            key: st,
            type: B.type || "item",
            ...B.type === "group" ? {} : { groupIndex: B.groupIndex }
          }
        ) : B.type === "group" ? /* @__PURE__ */ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(
          k,
          {
            ...Z(k, f),
            "data-index": q,
            "data-item-index": B.index,
            "data-known-size": B.size,
            key: st,
            style: tr
          },
          S(B.index, f)
        ) : /* @__PURE__ */ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(
          R,
          {
            ...Z(R, f),
            ...Qn(R, B.data),
            "data-index": q,
            "data-item-group-index": B.groupIndex,
            "data-item-index": B.index,
            "data-known-size": B.size,
            key: st,
            style: y ? er : Jn
          },
          P ? d(B.index, B.groupIndex, B.data, f) : d(B.index, B.data, f)
        );
      })
    }
  );
}), nr = {
  height: "100%",
  outline: "none",
  overflowY: "auto",
  position: "relative",
  WebkitOverflowScrolling: "touch"
}, or = {
  outline: "none",
  overflowX: "auto",
  position: "relative"
}, Zt = (t) => ({
  height: "100%",
  position: "absolute",
  top: 0,
  width: "100%",
  ...t ? { display: "flex", flexDirection: "column" } : {}
}), rr = {
  position: Xn(),
  top: 0,
  width: "100%",
  zIndex: 1
};
function Z(t, e) {
  if (typeof t != "string")
    return { context: e };
}
function Qn(t, e) {
  return { item: typeof t == "string" ? void 0 : e };
}
const sr = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.memo(function() {
  const e = W("HeaderComponent"), n = gt("headerHeight"), o = W("HeaderFooterTag"), r = Et(
    react__WEBPACK_IMPORTED_MODULE_1__.useMemo(
      () => (i) => {
        n(Ct(i, "height"));
      },
      [n]
    ),
    !0,
    W("skipAnimationFrameInResizeObserver")
  ), s = W("context");
  return e ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(o, { ref: r, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(e, { ...Z(e, s) }) }) : null;
}), ir = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.memo(function() {
  const e = W("FooterComponent"), n = gt("footerHeight"), o = W("HeaderFooterTag"), r = Et(
    react__WEBPACK_IMPORTED_MODULE_1__.useMemo(
      () => (i) => {
        n(Ct(i, "height"));
      },
      [n]
    ),
    !0,
    W("skipAnimationFrameInResizeObserver")
  ), s = W("context");
  return e ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(o, { ref: r, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(e, { ...Z(e, s) }) }) : null;
});
function Ye({ useEmitter: t, useEmitterValue: e, usePublisher: n }) {
  return react__WEBPACK_IMPORTED_MODULE_1__.memo(function({ children: s, style: i, ...l }) {
    const c = n("scrollContainerState"), d = e("ScrollerComponent"), f = n("smoothScrollTargetReached"), S = e("scrollerRef"), p = e("context"), m = e("horizontalDirection") || !1, { scrollByCallback: C, scrollerRef: I, scrollToCallback: y } = Zn(
      c,
      f,
      d,
      S,
      void 0,
      m
    );
    return t("scrollTo", y), t("scrollBy", C), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      d,
      {
        "data-testid": "virtuoso-scroller",
        "data-virtuoso-scroller": !0,
        ref: I,
        style: { ...m ? or : nr, ...i },
        tabIndex: 0,
        ...l,
        ...Z(d, p),
        children: s
      }
    );
  });
}
function Ze({ useEmitter: t, useEmitterValue: e, usePublisher: n }) {
  return react__WEBPACK_IMPORTED_MODULE_1__.memo(function({ children: s, style: i, ...l }) {
    const c = n("windowScrollContainerState"), d = e("ScrollerComponent"), f = n("smoothScrollTargetReached"), S = e("totalListHeight"), p = e("deviation"), m = e("customScrollParent"), C = e("context"), { scrollByCallback: I, scrollerRef: y, scrollToCallback: g } = Zn(
      c,
      f,
      d,
      Gt,
      m
    );
    return Yn(() => (y.current = m || window, () => {
      y.current = null;
    }), [y, m]), t("windowScrollTo", g), t("scrollBy", I), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      d,
      {
        "data-virtuoso-scroller": !0,
        style: { position: "relative", ...i, ...S !== 0 ? { height: S + p } : {} },
        ...l,
        ...Z(d, C),
        children: s
      }
    );
  });
}
const lr = ({ children: t }) => {
  const e = react__WEBPACK_IMPORTED_MODULE_1__.useContext(Re), n = gt("viewportHeight"), o = gt("fixedItemHeight"), r = W("alignToBottom"), s = W("horizontalDirection"), i = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(
    () => ne(n, (c) => Ct(c, s ? "width" : "height")),
    [n, s]
  ), l = Et(i, !0, W("skipAnimationFrameInResizeObserver"));
  return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    e && (n(e.viewportHeight), o(e.itemHeight));
  }, [e, n, o]), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { "data-viewport-type": "element", ref: l, style: Zt(r), children: t });
}, cr = ({ children: t }) => {
  const e = react__WEBPACK_IMPORTED_MODULE_1__.useContext(Re), n = gt("windowViewportRect"), o = gt("fixedItemHeight"), r = W("customScrollParent"), s = _e(
    n,
    r,
    W("skipAnimationFrameInResizeObserver")
  ), i = W("alignToBottom");
  return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    e && (o(e.itemHeight), n({ offsetTop: 0, visibleHeight: e.viewportHeight, visibleWidth: 100 }));
  }, [e, n, o]), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { "data-viewport-type": "window", ref: s, style: Zt(i), children: t });
}, ur = ({ children: t }) => {
  const e = W("TopItemListComponent") || "div", n = W("headerHeight"), o = { ...rr, marginTop: `${n}px` }, r = W("context");
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(e, { style: o, ...Z(e, r), children: t });
}, ar = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.memo(function(e) {
  const n = W("useWindowScroll"), o = W("topItemsIndexes").length > 0, r = W("customScrollParent"), s = W("context"), i = r || n ? fr : dr, l = r || n ? cr : lr;
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(i, { ...e, ...Z(i, s), children: [
    o && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ur, { children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(xn, { showTopList: !0 }) }),
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(l, { children: [
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sr, {}),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(xn, {}),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ir, {})
    ] })
  ] });
}), {
  Component: to,
  useEmitter: Xe,
  useEmitterValue: W,
  usePublisher: gt
} = /* @__PURE__ */ je(
  Jo,
  {
    events: {
      atBottomStateChange: "atBottomStateChange",
      atTopStateChange: "atTopStateChange",
      endReached: "endReached",
      groupIndices: "groupIndices",
      isScrolling: "isScrolling",
      itemsRendered: "itemsRendered",
      rangeChanged: "rangeChanged",
      startReached: "startReached",
      totalListHeightChanged: "totalListHeightChanged"
    },
    methods: {
      autoscrollToBottom: "autoscrollToBottom",
      getState: "getState",
      scrollBy: "scrollBy",
      scrollIntoView: "scrollIntoView",
      scrollTo: "scrollTo",
      scrollToIndex: "scrollToIndex"
    },
    optional: {
      alignToBottom: "alignToBottom",
      atBottomThreshold: "atBottomThreshold",
      atTopThreshold: "atTopThreshold",
      components: "components",
      computeItemKey: "computeItemKey",
      context: "context",
      customScrollParent: "customScrollParent",
      data: "data",
      defaultItemHeight: "defaultItemHeight",
      firstItemIndex: "firstItemIndex",
      fixedItemHeight: "fixedItemHeight",
      followOutput: "followOutput",
      groupContent: "groupContent",
      groupCounts: "groupCounts",
      headerFooterTag: "HeaderFooterTag",
      horizontalDirection: "horizontalDirection",
      increaseViewportBy: "increaseViewportBy",
      initialItemCount: "initialItemCount",
      initialScrollTop: "initialScrollTop",
      initialTopMostItemIndex: "initialTopMostItemIndex",
      itemContent: "itemContent",
      itemSize: "itemSize",
      logLevel: "logLevel",
      overscan: "overscan",
      restoreStateFrom: "restoreStateFrom",
      scrollerRef: "scrollerRef",
      scrollSeekConfiguration: "scrollSeekConfiguration",
      skipAnimationFrameInResizeObserver: "skipAnimationFrameInResizeObserver",
      topItemCount: "topItemCount",
      totalCount: "totalCount",
      useWindowScroll: "useWindowScroll"
    },
    required: {}
  },
  ar
), dr = /* @__PURE__ */ Ye({ useEmitter: Xe, useEmitterValue: W, usePublisher: gt }), fr = /* @__PURE__ */ Ze({ useEmitter: Xe, useEmitterValue: W, usePublisher: gt }), $r = to, Ur = (/* unused pure expression or super */ null && (to)), mr = /* @__PURE__ */ U(() => {
  const t = w((c) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("td", { children: [
    "Item $",
    c
  ] })), e = w(null), n = w(null), o = w(null), r = w({}), s = w(qe), i = w(Gt), l = (c, d = null) => ct(
    x(
      r,
      H((f) => f[c]),
      Y()
    ),
    d
  );
  return {
    components: r,
    computeItemKey: s,
    context: e,
    EmptyPlaceholder: l("EmptyPlaceholder"),
    FillerRow: l("FillerRow"),
    fixedFooterContent: o,
    fixedHeaderContent: n,
    itemContent: t,
    ScrollerComponent: l("Scroller", "div"),
    scrollerRef: i,
    ScrollSeekPlaceholder: l("ScrollSeekPlaceholder"),
    TableBodyComponent: l("TableBody", "tbody"),
    TableComponent: l("Table", "table"),
    TableFooterComponent: l("TableFoot", "tfoot"),
    TableHeadComponent: l("TableHead", "thead"),
    TableRowComponent: l("TableRow", "tr")
  };
}), pr = /* @__PURE__ */ U(
  ([t, e]) => ({ ...t, ...e }),
  X(jn, mr)
), hr = ({ height: t }) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tr", { children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", { style: { height: t } }) }), gr = ({ height: t }) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tr", { children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", { style: { border: 0, height: t, padding: 0 } }) }), Ir = { overflowAnchor: "none" }, Tn = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.memo(function({ showTopList: e = !1 }) {
  const n = _("listState"), o = _("computeItemKey"), r = _("firstItemIndex"), s = _("isSeeking"), i = _("ScrollSeekPlaceholder") || hr, l = _("context"), c = _("TableRowComponent"), d = _("fixedHeaderHeight"), f = _("itemContent"), S = (e ? n.topItems : []).reduce((m, C, I) => (I === 0 ? m.push(C.size) : m.push(m[I - 1] + C.size), m), []), p = (e ? n.topItems : n.items).map((m) => {
    const C = m.originalIndex, I = o(C + r, m.data, l), y = e ? C === 0 ? 0 : S[C - 1] : 0;
    return s ? /* @__PURE__ */ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(
      i,
      {
        ...Z(i, l),
        height: m.size,
        index: m.index,
        key: I,
        type: m.type || "item"
      }
    ) : /* @__PURE__ */ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(
      c,
      {
        ...Z(c, l),
        ...Qn(c, m.data),
        "data-index": C,
        "data-item-index": m.index,
        "data-known-size": m.size,
        key: I,
        style: e ? { overflowAnchor: "none", position: "sticky", top: d + y, zIndex: 2 } : Ir
      },
      f(m.index, m.data, l)
    );
  });
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: p });
}), Sr = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.memo(function() {
  const e = _("listState"), n = _("topItemsIndexes").length > 0, o = Tt("sizeRanges"), r = _("useWindowScroll"), s = _("customScrollParent"), i = Tt("windowScrollContainerState"), l = Tt("scrollContainerState"), c = s || r ? i : l, d = _("trackItemSizes"), f = _("itemSize"), S = _("log"), { callbackRef: p, ref: m } = kn(
    o,
    f,
    d,
    c,
    S,
    void 0,
    s,
    !1,
    _("skipAnimationFrameInResizeObserver")
  ), [C, I] = react__WEBPACK_IMPORTED_MODULE_1__.useState(0);
  Je("deviation", (P) => {
    C !== P && (m.current.style.marginTop = `${P}px`, I(P));
  });
  const y = _("EmptyPlaceholder"), g = _("FillerRow") || gr, u = _("TableBodyComponent"), T = _("paddingTopAddition"), b = _("statefulTotalCount"), h = _("context");
  if (b === 0 && y)
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(y, { ...Z(y, h) });
  const a = (n ? e.topItems : []).reduce((P, D) => P + D.size, 0), R = e.offsetTop + T + C - a, k = e.offsetBottom, O = R > 0 ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(g, { context: h, height: R }, "padding-top") : null, z = k > 0 ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(g, { context: h, height: k }, "padding-bottom") : null;
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(u, { "data-testid": "virtuoso-item-list", ref: p, ...Z(u, h), children: [
    O,
    n && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tn, { showTopList: !0 }),
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tn, {}),
    z
  ] });
}), xr = ({ children: t }) => {
  const e = react__WEBPACK_IMPORTED_MODULE_1__.useContext(Re), n = Tt("viewportHeight"), o = Tt("fixedItemHeight"), r = Et(
    react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => ne(n, (s) => Ct(s, "height")), [n]),
    !0,
    _("skipAnimationFrameInResizeObserver")
  );
  return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    e && (n(e.viewportHeight), o(e.itemHeight));
  }, [e, n, o]), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { "data-viewport-type": "element", ref: r, style: Zt(!1), children: t });
}, Tr = ({ children: t }) => {
  const e = react__WEBPACK_IMPORTED_MODULE_1__.useContext(Re), n = Tt("windowViewportRect"), o = Tt("fixedItemHeight"), r = _("customScrollParent"), s = _e(
    n,
    r,
    _("skipAnimationFrameInResizeObserver")
  );
  return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    e && (o(e.itemHeight), n({ offsetTop: 0, visibleHeight: e.viewportHeight, visibleWidth: 100 }));
  }, [e, n, o]), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { "data-viewport-type": "window", ref: s, style: Zt(!1), children: t });
}, wr = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.memo(function(e) {
  const n = _("useWindowScroll"), o = _("customScrollParent"), r = Tt("fixedHeaderHeight"), s = Tt("fixedFooterHeight"), i = _("fixedHeaderContent"), l = _("fixedFooterContent"), c = _("context"), d = Et(
    react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => ne(r, (u) => Ct(u, "height")), [r]),
    !0,
    _("skipAnimationFrameInResizeObserver")
  ), f = Et(
    react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => ne(s, (u) => Ct(u, "height")), [s]),
    !0,
    _("skipAnimationFrameInResizeObserver")
  ), S = o || n ? vr : yr, p = o || n ? Tr : xr, m = _("TableComponent"), C = _("TableHeadComponent"), I = _("TableFooterComponent"), y = i ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    C,
    {
      ref: d,
      style: { position: "sticky", top: 0, zIndex: 2 },
      ...Z(C, c),
      children: i()
    },
    "TableHead"
  ) : null, g = l ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    I,
    {
      ref: f,
      style: { bottom: 0, position: "sticky", zIndex: 1 },
      ...Z(I, c),
      children: l()
    },
    "TableFoot"
  ) : null;
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(S, { ...e, ...Z(S, c), children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(p, { children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(m, { style: { borderSpacing: 0, overflowAnchor: "none" }, ...Z(m, c), children: [
    y,
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Sr, {}, "TableBody"),
    g
  ] }) }) });
}), {
  Component: Cr,
  useEmitter: Je,
  useEmitterValue: _,
  usePublisher: Tt
} = /* @__PURE__ */ je(
  pr,
  {
    events: {
      atBottomStateChange: "atBottomStateChange",
      atTopStateChange: "atTopStateChange",
      endReached: "endReached",
      groupIndices: "groupIndices",
      isScrolling: "isScrolling",
      itemsRendered: "itemsRendered",
      rangeChanged: "rangeChanged",
      startReached: "startReached",
      totalListHeightChanged: "totalListHeightChanged"
    },
    methods: {
      getState: "getState",
      scrollBy: "scrollBy",
      scrollIntoView: "scrollIntoView",
      scrollTo: "scrollTo",
      scrollToIndex: "scrollToIndex"
    },
    optional: {
      alignToBottom: "alignToBottom",
      atBottomThreshold: "atBottomThreshold",
      atTopThreshold: "atTopThreshold",
      components: "components",
      computeItemKey: "computeItemKey",
      context: "context",
      customScrollParent: "customScrollParent",
      data: "data",
      defaultItemHeight: "defaultItemHeight",
      firstItemIndex: "firstItemIndex",
      fixedFooterContent: "fixedFooterContent",
      fixedHeaderContent: "fixedHeaderContent",
      fixedItemHeight: "fixedItemHeight",
      followOutput: "followOutput",
      groupCounts: "groupCounts",
      increaseViewportBy: "increaseViewportBy",
      initialItemCount: "initialItemCount",
      initialScrollTop: "initialScrollTop",
      initialTopMostItemIndex: "initialTopMostItemIndex",
      itemContent: "itemContent",
      itemSize: "itemSize",
      logLevel: "logLevel",
      overscan: "overscan",
      restoreStateFrom: "restoreStateFrom",
      scrollerRef: "scrollerRef",
      scrollSeekConfiguration: "scrollSeekConfiguration",
      topItemCount: "topItemCount",
      totalCount: "totalCount",
      useWindowScroll: "useWindowScroll"
    },
    required: {}
  },
  wr
), yr = /* @__PURE__ */ Ye({ useEmitter: Je, useEmitterValue: _, usePublisher: Tt }), vr = /* @__PURE__ */ Ze({ useEmitter: Je, useEmitterValue: _, usePublisher: Tt }), Kr = (/* unused pure expression or super */ null && (Cr)), wn = {
  bottom: 0,
  itemHeight: 0,
  items: [],
  itemWidth: 0,
  offsetBottom: 0,
  offsetTop: 0,
  top: 0
}, br = {
  bottom: 0,
  itemHeight: 0,
  items: [{ index: 0 }],
  itemWidth: 0,
  offsetBottom: 0,
  offsetTop: 0,
  top: 0
}, { ceil: Cn, floor: we, max: ee, min: Oe, round: yn } = Math;
function vn(t, e, n) {
  return Array.from({ length: e - t + 1 }).map((o, r) => ({ data: n === null ? null : n[r + t], index: r + t }));
}
function Rr(t) {
  return {
    ...br,
    items: t
  };
}
function he(t, e) {
  return t && t.width === e.width && t.height === e.height;
}
function Er(t, e) {
  return t && t.column === e.column && t.row === e.row;
}
const Hr = /* @__PURE__ */ U(
  ([
    { increaseViewportBy: t, listBoundary: e, overscan: n, visibleRange: o },
    { footerHeight: r, headerHeight: s, scrollBy: i, scrollContainerState: l, scrollTo: c, scrollTop: d, smoothScrollTargetReached: f, viewportHeight: S },
    p,
    m,
    { didMount: C, propsReady: I },
    { customScrollParent: y, useWindowScroll: g, windowScrollContainerState: u, windowScrollTo: T, windowViewportRect: b },
    h
  ]) => {
    const a = w(0), R = w(0), k = w(wn), O = w({ height: 0, width: 0 }), z = w({ height: 0, width: 0 }), P = $(), D = $(), J = w(0), nt = w(null), B = w({ column: 0, row: 0 }), q = $(), st = $(), dt = w(!1), St = w(0), ft = w(!0), ut = w(!1), At = w(!1);
    K(
      x(
        C,
        G(St),
        V(([v, N]) => !!N)
      ),
      () => {
        M(ft, !1);
      }
    ), K(
      x(
        rt(C, ft, z, O, St, ut),
        V(([v, N, Q, it, , tt]) => v && !N && Q.height !== 0 && it.height !== 0 && !tt)
      ),
      ([, , , , v]) => {
        M(ut, !0), De(1, () => {
          M(P, v);
        }), Rt(x(d), () => {
          M(e, [0, 0]), M(ft, !0);
        });
      }
    ), F(
      x(
        st,
        V((v) => v != null && v.scrollTop > 0),
        vt(0)
      ),
      R
    ), K(
      x(
        C,
        G(st),
        V(([, v]) => v != null)
      ),
      ([, v]) => {
        v && (M(O, v.viewport), M(z, v.item), M(B, v.gap), v.scrollTop > 0 && (M(dt, !0), Rt(x(d, qt(1)), (N) => {
          M(dt, !1);
        }), M(c, { top: v.scrollTop })));
      }
    ), F(
      x(
        O,
        H(({ height: v }) => v)
      ),
      S
    ), F(
      x(
        rt(
          A(O, he),
          A(z, he),
          A(B, (v, N) => v && v.column === N.column && v.row === N.row),
          A(d)
        ),
        H(([v, N, Q, it]) => ({
          gap: Q,
          item: N,
          scrollTop: it,
          viewport: v
        }))
      ),
      q
    ), F(
      x(
        rt(
          A(a),
          o,
          A(B, Er),
          A(z, he),
          A(O, he),
          A(nt),
          A(R),
          A(dt),
          A(ft),
          A(St)
        ),
        V(([, , , , , , , v]) => !v),
        H(
          ([
            v,
            [N, Q],
            it,
            tt,
            kt,
            Jt,
            Dt,
            ,
            de,
            Ot
          ]) => {
            const { column: Ft, row: Qt } = it, { height: fe, width: Ee } = tt, { width: Qe } = kt;
            if (Dt === 0 && (v === 0 || Qe === 0))
              return wn;
            if (Ee === 0) {
              const rn = $e(Ot, v), ro = rn + Math.max(Dt - 1, 0);
              return Rr(vn(rn, ro, Jt));
            }
            const me = eo(Qe, Ee, Ft);
            let $t, Mt;
            de ? N === 0 && Q === 0 && Dt > 0 ? ($t = 0, Mt = Dt - 1) : ($t = me * we((N + Qt) / (fe + Qt)), Mt = me * Cn((Q + Qt) / (fe + Qt)) - 1, Mt = Oe(v - 1, ee(Mt, me - 1)), $t = Oe(Mt, ee(0, $t))) : ($t = 0, Mt = -1);
            const tn = vn($t, Mt, Jt), { bottom: en, top: nn } = bn(kt, it, tt, tn), on = Cn(v / me), oo = on * fe + (on - 1) * Qt - en;
            return { bottom: en, itemHeight: fe, items: tn, itemWidth: Ee, offsetBottom: oo, offsetTop: nn, top: nn };
          }
        )
      ),
      k
    ), F(
      x(
        nt,
        V((v) => v !== null),
        H((v) => v.length)
      ),
      a
    ), F(
      x(
        rt(O, z, k, B),
        V(([v, N, { items: Q }]) => Q.length > 0 && N.height !== 0 && v.height !== 0),
        H(([v, N, { items: Q }, it]) => {
          const { bottom: tt, top: kt } = bn(v, it, N, Q);
          return [kt, tt];
        }),
        Y(se)
      ),
      e
    );
    const xt = w(!1);
    F(
      x(
        d,
        G(xt),
        H(([v, N]) => N || v !== 0)
      ),
      xt
    );
    const Xt = pt(
      x(
        rt(k, a),
        V(([{ items: v }]) => v.length > 0),
        G(xt),
        V(([[v, N], Q]) => {
          const tt = v.items[v.items.length - 1].index === N - 1;
          return (Q || v.bottom > 0 && v.itemHeight > 0 && v.offsetBottom === 0 && v.items.length === N) && tt;
        }),
        H(([[, v]]) => v - 1),
        Y()
      )
    ), Wt = pt(
      x(
        A(k),
        V(({ items: v }) => v.length > 0 && v[0].index === 0),
        vt(0),
        Y()
      )
    ), yt = pt(
      x(
        A(k),
        G(dt),
        V(([{ items: v }, N]) => v.length > 0 && !N),
        H(([{ items: v }]) => ({
          endIndex: v[v.length - 1].index,
          startIndex: v[0].index
        })),
        Y(Vn),
        zt(0)
      )
    );
    F(yt, m.scrollSeekRangeChanged), F(
      x(
        P,
        G(O, z, a, B),
        H(([v, N, Q, it, tt]) => {
          const kt = Gn(v), { align: Jt, behavior: Dt, offset: de } = kt;
          let Ot = kt.index;
          Ot === "LAST" && (Ot = it - 1), Ot = ee(0, Ot, Oe(it - 1, Ot));
          let Ft = Ve(N, tt, Q, Ot);
          return Jt === "end" ? Ft = yn(Ft - N.height + Q.height) : Jt === "center" && (Ft = yn(Ft - N.height / 2 + Q.height / 2)), de && (Ft += de), { behavior: Dt, top: Ft };
        })
      ),
      c
    );
    const Bt = ct(
      x(
        k,
        H((v) => v.offsetBottom + v.bottom)
      ),
      0
    );
    return F(
      x(
        b,
        H((v) => ({ height: v.visibleHeight, width: v.visibleWidth }))
      ),
      O
    ), {
      customScrollParent: y,
      // input
      data: nt,
      deviation: J,
      footerHeight: r,
      gap: B,
      headerHeight: s,
      increaseViewportBy: t,
      initialItemCount: R,
      itemDimensions: z,
      overscan: n,
      restoreStateFrom: st,
      scrollBy: i,
      scrollContainerState: l,
      scrollHeight: D,
      scrollTo: c,
      scrollToIndex: P,
      scrollTop: d,
      smoothScrollTargetReached: f,
      totalCount: a,
      useWindowScroll: g,
      viewportDimensions: O,
      windowScrollContainerState: u,
      windowScrollTo: T,
      windowViewportRect: b,
      ...m,
      // output
      gridState: k,
      horizontalDirection: At,
      initialTopMostItemIndex: St,
      totalListHeight: Bt,
      ...p,
      endReached: Xt,
      propsReady: I,
      rangeChanged: yt,
      startReached: Wt,
      stateChanged: q,
      stateRestoreInProgress: dt,
      ...h
    };
  },
  X(Ue, at, ae, Un, Vt, Ke, Pt)
);
function eo(t, e, n) {
  return ee(1, we((t + n) / (we(e) + n)));
}
function bn(t, e, n, o) {
  const { height: r } = n;
  if (r === void 0 || o.length === 0)
    return { bottom: 0, top: 0 };
  const s = Ve(t, e, n, o[0].index);
  return { bottom: Ve(t, e, n, o[o.length - 1].index) + r, top: s };
}
function Ve(t, e, n, o) {
  const r = eo(t.width, n.width, e.column), s = we(o / r), i = s * n.height + ee(0, s - 1) * e.row;
  return i > 0 ? i + e.row : i;
}
const Br = /* @__PURE__ */ U(() => {
  const t = w((S) => `Item ${S}`), e = w({}), n = w(null), o = w("virtuoso-grid-item"), r = w("virtuoso-grid-list"), s = w(qe), i = w("div"), l = w(Gt), c = (S, p = null) => ct(
    x(
      e,
      H((m) => m[S]),
      Y()
    ),
    p
  ), d = w(!1), f = w(!1);
  return F(A(f), d), {
    components: e,
    computeItemKey: s,
    context: n,
    FooterComponent: c("Footer"),
    HeaderComponent: c("Header"),
    headerFooterTag: i,
    itemClassName: o,
    ItemComponent: c("Item", "div"),
    itemContent: t,
    listClassName: r,
    ListComponent: c("List", "div"),
    readyStateChanged: d,
    reportReadyState: f,
    ScrollerComponent: c("Scroller", "div"),
    scrollerRef: l,
    ScrollSeekPlaceholder: c("ScrollSeekPlaceholder", "div")
  };
}), kr = /* @__PURE__ */ U(
  ([t, e]) => ({ ...t, ...e }),
  X(Hr, Br)
), Or = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.memo(function() {
  const e = et("gridState"), n = et("listClassName"), o = et("itemClassName"), r = et("itemContent"), s = et("computeItemKey"), i = et("isSeeking"), l = It("scrollHeight"), c = et("ItemComponent"), d = et("ListComponent"), f = et("ScrollSeekPlaceholder"), S = et("context"), p = It("itemDimensions"), m = It("gap"), C = et("log"), I = et("stateRestoreInProgress"), y = It("reportReadyState"), g = Et(
    react__WEBPACK_IMPORTED_MODULE_1__.useMemo(
      () => (u) => {
        const T = u.parentElement.parentElement.scrollHeight;
        l(T);
        const b = u.firstChild;
        if (b) {
          const { height: h, width: a } = b.getBoundingClientRect();
          p({ height: h, width: a });
        }
        m({
          column: Rn("column-gap", getComputedStyle(u).columnGap, C),
          row: Rn("row-gap", getComputedStyle(u).rowGap, C)
        });
      },
      [l, p, m, C]
    ),
    !0,
    !1
  );
  return Yn(() => {
    e.itemHeight > 0 && e.itemWidth > 0 && y(!0);
  }, [e]), I ? null : /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    d,
    {
      className: n,
      ref: g,
      ...Z(d, S),
      "data-testid": "virtuoso-item-list",
      style: { paddingBottom: e.offsetBottom, paddingTop: e.offsetTop },
      children: e.items.map((u) => {
        const T = s(u.index, u.data, S);
        return i ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
          f,
          {
            ...Z(f, S),
            height: e.itemHeight,
            index: u.index,
            width: e.itemWidth
          },
          T
        ) : /* @__PURE__ */ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(
          c,
          {
            ...Z(c, S),
            className: o,
            "data-index": u.index,
            key: T
          },
          r(u.index, u.data, S)
        );
      })
    }
  );
}), Fr = react__WEBPACK_IMPORTED_MODULE_1__.memo(function() {
  const e = et("HeaderComponent"), n = It("headerHeight"), o = et("headerFooterTag"), r = Et(
    react__WEBPACK_IMPORTED_MODULE_1__.useMemo(
      () => (i) => {
        n(Ct(i, "height"));
      },
      [n]
    ),
    !0,
    !1
  ), s = et("context");
  return e ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(o, { ref: r, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(e, { ...Z(e, s) }) }) : null;
}), zr = react__WEBPACK_IMPORTED_MODULE_1__.memo(function() {
  const e = et("FooterComponent"), n = It("footerHeight"), o = et("headerFooterTag"), r = Et(
    react__WEBPACK_IMPORTED_MODULE_1__.useMemo(
      () => (i) => {
        n(Ct(i, "height"));
      },
      [n]
    ),
    !0,
    !1
  ), s = et("context");
  return e ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(o, { ref: r, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(e, { ...Z(e, s) }) }) : null;
}), Lr = ({ children: t }) => {
  const e = react__WEBPACK_IMPORTED_MODULE_1__.useContext(qn), n = It("itemDimensions"), o = It("viewportDimensions"), r = Et(
    react__WEBPACK_IMPORTED_MODULE_1__.useMemo(
      () => (s) => {
        o(s.getBoundingClientRect());
      },
      [o]
    ),
    !0,
    !1
  );
  return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    e && (o({ height: e.viewportHeight, width: e.viewportWidth }), n({ height: e.itemHeight, width: e.itemWidth }));
  }, [e, o, n]), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { ref: r, style: Zt(!1), children: t });
}, Pr = ({ children: t }) => {
  const e = react__WEBPACK_IMPORTED_MODULE_1__.useContext(qn), n = It("windowViewportRect"), o = It("itemDimensions"), r = et("customScrollParent"), s = _e(n, r, !1);
  return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    e && (o({ height: e.itemHeight, width: e.itemWidth }), n({ offsetTop: 0, visibleHeight: e.viewportHeight, visibleWidth: e.viewportWidth }));
  }, [e, n, o]), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { ref: s, style: Zt(!1), children: t });
}, Vr = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.memo(function({ ...e }) {
  const n = et("useWindowScroll"), o = et("customScrollParent"), r = o || n ? Mr : Wr, s = o || n ? Pr : Lr, i = et("context");
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(r, { ...e, ...Z(r, i), children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(s, { children: [
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Fr, {}),
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Or, {}),
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(zr, {})
  ] }) });
}), {
  Component: Ar,
  useEmitter: no,
  useEmitterValue: et,
  usePublisher: It
} = /* @__PURE__ */ je(
  kr,
  {
    events: {
      atBottomStateChange: "atBottomStateChange",
      atTopStateChange: "atTopStateChange",
      endReached: "endReached",
      isScrolling: "isScrolling",
      rangeChanged: "rangeChanged",
      readyStateChanged: "readyStateChanged",
      startReached: "startReached",
      stateChanged: "stateChanged"
    },
    methods: {
      scrollBy: "scrollBy",
      scrollTo: "scrollTo",
      scrollToIndex: "scrollToIndex"
    },
    optional: {
      components: "components",
      computeItemKey: "computeItemKey",
      context: "context",
      customScrollParent: "customScrollParent",
      data: "data",
      headerFooterTag: "headerFooterTag",
      increaseViewportBy: "increaseViewportBy",
      initialItemCount: "initialItemCount",
      initialTopMostItemIndex: "initialTopMostItemIndex",
      itemClassName: "itemClassName",
      itemContent: "itemContent",
      listClassName: "listClassName",
      logLevel: "logLevel",
      overscan: "overscan",
      restoreStateFrom: "restoreStateFrom",
      scrollerRef: "scrollerRef",
      scrollSeekConfiguration: "scrollSeekConfiguration",
      totalCount: "totalCount",
      useWindowScroll: "useWindowScroll"
    }
  },
  Vr
), Wr = /* @__PURE__ */ Ye({ useEmitter: no, useEmitterValue: et, usePublisher: It }), Mr = /* @__PURE__ */ Ze({ useEmitter: no, useEmitterValue: et, usePublisher: It });
function Rn(t, e, n) {
  return e !== "normal" && !(e != null && e.endsWith("px")) && n(`${t} was not resolved to pixel value correctly`, e, ht.WARN), e === "normal" ? 0 : parseInt(e != null ? e : "0", 10);
}
const jr = (/* unused pure expression or super */ null && (Ar));



/***/ })

}]);